/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.22.595 on 2026-09-08 23:04:36.

export interface OrganizationDetailData extends AbstractNamedData {
    users: Link<User>[];
    roads: RoadSimpleData[];
    authorizedUsers: Link<User>[];
    code: string;
}

export interface OrganizationResumeData extends AbstractNamedData {
    code: string;
}

export interface RoleDetailData extends AbstractNamedData {
}

export interface AbstractUserData extends AbstractNamedData {
    login: string;
    email: string;
}

export interface UserDetailData extends AbstractUserData {
    active: boolean;
    system: boolean;
    language: string;
    timezone: string;
    authorities: Authority[];
    roles: Link<Role>[];
    baseUrl: string;
}

export interface UserSearchData extends AbstractUserData {
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    active: boolean;
    authorities: string[];
    roles: Link<Role>[];
}

export interface AllPlansByProjectData extends AbstractData {
    name: string;
    organization: Link<Organization>;
    items: AllPlansByProjectItemDetailData[];
}

export interface AllPlansByProjectItemDetailData extends AbstractData {
    road: Link<Road>;
    plan: Link<Plan>;
}

export interface BudgetLimitData extends AbstractData {
    items: BudgetLimitItem[];
    name: string;
    createdBy: string;
    createdAt: Date;
    updatedBy: string;
    updatedAt: Date;
}

export interface BudgetLimitItemData extends AbstractData {
    owner: BudgetLimit;
    limit: number;
    dateLimit: Date;
}

export interface BuiltData extends MeasurementData {
    extension: string;
    solution: string;
    solutionType: string;
    dataSource: DataSourceEnum;
    idSysrunner: string;
    kartadoUpdatedAt: Date;
}

export interface ConstantHistoricData extends AbstractData {
    versionPlan: number;
    idConstantHistoric: number;
    idPlan: number;
    dtUpdate: Date;
    name: string;
    k1: number;
    k2: number;
    k3: number;
    k4: number;
    k5: number;
    k6: number;
    k7: number;
    k8: number;
    k9: number;
    k10: number;
    k11: number;
}

export interface CostTableHistoricData extends AbstractData {
    idCostTabletHistoric: number;
    idPlan: number;
    versionPlan: number;
    dtUpdate: Date;
    idCostTable: number;
    nameCostTable: string;
    idCostTableItem: number;
    idSolution: number;
    nameSolution: string;
    cost: number;
}

export interface DecisionTreeNodeGroupData extends DecisionTreeNodeItemData {
    operator: BooleanOperators;
    items: DecisionTreeNodeItemData[];
}

export interface DecisionTreeNodeItemData extends AbstractData {
    type: DecisionTreeNodeItemType;
}

export interface DecisionTreeNodeSingleData extends DecisionTreeNodeItemData {
    operator: LogicalOperators;
    lhsMetric: Metrics;
    lhsValue: number;
    rhsMetric: Metrics;
    rhsValue: number;
}

export interface DecisionTreeItemData extends AbstractData {
    type: DecisionTreeItemType;
}

export interface DecisionTreeLeafData extends DecisionTreeItemData {
    solutions: Link<Solution>[];
    subtrees: Link<DecisionTree>[];
}

export interface DecisionTreeNodeData extends DecisionTreeItemData {
    condition: DecisionTreeNodeItemData;
    positive: DecisionTreeItemData;
    negative: DecisionTreeItemData;
}

export interface DecisionTreeAbstractData extends AbstractNamedData {
}

export interface DecisionTreeData extends DecisionTreeAbstractData {
}

export interface DecisionTreeDetailData extends DecisionTreeAbstractData {
    root: DecisionTreeItemData;
    project: ProjectData;
    situation: DecisionTreeSituation;
}

export interface DecisionTreeSearchData extends DecisionTreeAbstractData {
}

export interface DecisionTreeHistoricData extends AbstractData {
    idDecisionTreeHistoric: number;
    idPlan: number;
    versionPlan: number;
    namePlan: string;
    idDecisionTreeMain: number;
    nameDecisionTreeMain: string;
    idDecisionTreeItem: number;
    typeDecisionTreeItem: string;
    root: boolean;
    idPositiveDecisionTreeItem: number;
    idNegativeDecisionTreeItem: number;
    typeSetDecisionTreeNodeItem: string;
    operator: string;
    lhsMetric: string;
    lhsValue: number;
    rhsMetric: string;
    rhsValue: number;
    idParentDecisionTreeNodeItem: number;
    idSolutionDecisionTree: number;
    nameSolutionDecisionTreeItem: string;
    idSubDecisionTree: number;
    nameSubDecisionTree: string;
}

export interface FwdData extends MeasurementData {
    force: number;
    d0: number;
    d20: number;
    d30: number;
    d45: number;
    d60: number;
    d90: number;
    d120: number;
    airTemperature: number;
    pavementTemperature: number;
    normalizedD0: number;
    normalizedD20: number;
    normalizedD30: number;
    normalizedD45: number;
    normalizedD60: number;
    normalizedD90: number;
    normalizedD120: number;
    curvatureRadius: number;
    deltaD0D45: number;
    radius: number;
}

export interface GripData extends MeasurementData {
    speed: number;
    gn: number;
}

export interface HsData extends MeasurementData {
    hs: number;
    surfaceType: string;
}

export interface IcpData extends MeasurementData {
    extension: string;
    apA: string;
    boA: string;
    deA: string;
    djA: string;
    dpaA: string;
    dsjA: string;
    ejA: string;
    fcA: string;
    flA: string;
    frA: string;
    grA: string;
    pbA: string;
    pdA: string;
    pnA: string;
    prA: string;
    qcA: string;
    qlA: string;
    reA: string;
    apM: string;
    boM: string;
    deM: string;
    djM: string;
    dpaM: string;
    dsjM: string;
    ejM: string;
    fcM: string;
    flM: string;
    frM: string;
    grM: string;
    pbM: string;
    pdM: string;
    pnM: string;
    prM: string;
    qcM: string;
    qlM: string;
    reM: string;
    apB: string;
    boB: string;
    deB: string;
    djB: string;
    dpaB: string;
    dsjB: string;
    ejB: string;
    fcB: string;
    flB: string;
    frB: string;
    grB: string;
    pbB: string;
    pdB: string;
    pnB: string;
    prB: string;
    qcB: string;
    qlB: string;
    reB: string;
    icp: number;
}

export interface IfiData extends MeasurementData {
    macrotextureEquipment: string;
    macrotextureMeasure: number;
    microtextureEquipment: string;
    microtextureMeasure: number;
    fr60: number;
    ifiSp: number;
    ifiF60: number;
    classification: string;
}

export interface IggData extends MeasurementData {
    earthmovingSection: string;
    coveringType: string;
    ok: boolean;
    fi: boolean;
    ttc: boolean;
    ttl: boolean;
    tlc: boolean;
    tll: boolean;
    trr: boolean;
    j: boolean;
    tb: boolean;
    je: boolean;
    tbe: boolean;
    alp: boolean;
    atp: boolean;
    o: boolean;
    p: boolean;
    ex: boolean;
    d: boolean;
    r: boolean;
    alc: boolean;
    atc: boolean;
    e: boolean;
    outerFl: number;
    innerFl: number;
    fc2: number;
    fc3: number;
    pa: number;
    atOn: number;
    igi: number;
    atrAverage: number;
    atrVariance: number;
    igg: number;
}

export interface IqdCalculationData extends AbstractData {
    name: string;
    iqdtype: IqdType;
    organization: Link<Organization>;
    project: Link<Project>;
    items: IqdCalculationItemDetailData[];
    iqd: number;
    comfortValue: number;
    totalSegmentsComfort: number;
    securityValue: number;
    totalSegmentsSecurity: number;
    surfaceValue: number;
    totalSegmentsSurface: number;
    totalSegments: number;
    totalAcceptedSegmentsComfort: number;
    totalAcceptedSegmentsSecurity: number;
    totalAcceptedSegmentsSurface: number;
}

export interface IqdCalculationItemDetailData extends AbstractData {
    road: Link<Road>;
    plan: Link<Plan>;
    acceptedSegmentsComfort: number;
    totalSegmentsComfort: number;
    acceptedSegmentsSecurity: number;
    totalSegmentsSecurity: number;
    acceptedSegmentsSurface: number;
    totalSegmentsSurface: number;
    totalSegments: number;
}

export interface IriData extends MeasurementData {
    speed: number;
    innerIri: number;
    outerIri: number;
    innerQi: number;
    outerQi: number;
    iriAverage: number;
    qiAverage: number;
}

export interface KpiData extends AbstractData {
    headMilestone: number;
    tailMilestone: number;
    direction: Direction;
    solutions: Link<Solution>[];
    cost: number;
    plan: PlanResumeData;
    area: number;
    areaWithoutSafetyArea: number;
    interventionArea: number;
    lane: number;
    noise: number;
    ifi: number;
    vrd: number;
    gn: number;
    d0: number;
    dadm: number;
    fc3: number;
    fc2: number;
    urci: number;
    hs: number;
    dc: number;
    snc: number;
    d120: number;
    radius: number;
    qi: number;
    iri: number;
    igg: number;
    arrow: number;
    tr: number;
    trAge: number;
    heavyVehicleDailyAverage: number;
    usaceVehicleFactor: number;
    aashtoVehicleFactor: number;
    usaceNumber: number;
    aashtoYearNumber: number;
    year: number;
    hrPro011: number;
    hrPro159: number;
    hrPro269: number;
    beforeHrPro011: number;
    beforeHrPro159: number;
    beforeHrPro269: number;
    sumCostForYear: number;
    sumCostKpiAllYears: number;
    indexCrossing: boolean;
    presentMeasurements: Measurements[];
    missingMeasurements: Measurements[];
    materialsServices: string[];
    segmentsFiltered: SegmentsData[];
    beforeCost: number;
    beforeSnc: number;
    beforeNoise: number;
    beforeIfi: number;
    beforeVrd: number;
    beforeGn: number;
    beforeD0: number;
    beforeUrci: number;
    beforeFc2: number;
    beforeFc3: number;
    beforeDadm: number;
    beforeHs: number;
    beforeD120: number;
    beforeRadius: number;
    beforeQi: number;
    beforeIri: number;
    beforeIgg: number;
    beforeArrow: number;
    beforeTr: number;
    beforeTrAge: number;
    beforeHeavyVehicleDailyAverage: number;
    beforeUsaceVehicleFactor: number;
    beforeAashtoVehicleFactor: number;
    beforeUsaceNumber: number;
    beforeAashtoYearNumber: number;
    beforeDc: number;
    conditions: string;
}

export interface LifespanData extends AbstractData {
    headMilestone: number;
    tailMilestone: number;
    direction: Direction;
    lane: number;
    firstAgeDcIntervention: number;
    firstAgeQiIntervention: number;
    firstAgeIggIntervention: number;
    firstAgeArrowIntervention: number;
    firstAgeTrIntervention: number;
    minimum: number;
}

export interface MaterialsServicesData extends AbstractData {
    name: string;
    unit: Units;
    value: number;
    idUnitPriceTable: number;
}

export interface MeasurementData extends AbstractData {
    organization: Link<Organization>;
    road: Link<Road>;
    campaign: Link<Campaign>;
    headMilestone: number;
    tailMilestone: number;
    direction: Direction;
    lane: number;
    dateTime: Date;
    comments: string;
    markerKilometer: number;
    milestone: number;
}

export interface MechanicalAnalysisData extends MeasurementData {
    pavingType: number;
    layer1: number[];
    layer2: number[];
    layer3: number[];
    subgrade: number[];
    usaceCoefficient: number;
    usaceExponent: number;
    aashtoCoefficient: number;
    aashtoExponent: number;
    deflection: number;
    horizontalDeformation: number;
    verticalDeformation: number;
    horizontalTension: number;
}

export interface MechanisticAnalysisData extends AbstractData {
    code: string;
    deflection: number;
    horizontalDeformation: number;
    verticalDeformation: number;
    horizontalTension: number;
}

export interface StatusProcessEntityData extends AbstractData {
    name: string;
    status: StatusProcessEntityType;
    module: string;
    description: string;
    entityId: number;
    entityType: string;
}

export interface MetricLimitData extends AbstractData {
    organization: Link<Organization>;
    metric: Metrics;
    goodLimit: number;
    badLimit: number;
    maxLimit: number;
    minLimit: number;
}

export interface NoiseData extends MeasurementData {
    speed: number;
    noise: number;
}

export interface ParameterEvolutionData extends AbstractData {
    name: string;
    road: Link<Road>;
    organization: Link<Organization>;
    campaign: Link<Campaign>;
    constantSet: Link<ConstantSet>;
    growthRate: Link<GrowthRate>;
    rateType: RateType;
    headMilestone: number;
    tailMilestone: number;
    segmentLength: number;
    trafficGrowthRate: number;
    requestedYears: number;
    consideredCampaigns: CampaignDetailData[];
}

export interface PlanOverviewData extends AbstractData {
}

export interface IndexCrossingItemPlanData extends AbstractData {
    operator: LogicalOperators;
    lhsMetric: Metrics;
    lhsValue: number;
    rhsMetric: Metrics;
    rhsValue: number;
    dtype: DecisionTreeNodeItemType;
}

export interface PlanData extends AbstractData {
    name: string;
    versionPlan: number;
    organization: Link<Organization>;
    road: Link<Road>;
    roadtype: RoadType;
    campaign: Link<Campaign>;
    criteriaSet?: CriteriaSet;
    decisionTree: DecisionTreeData;
    secondaryDecisionTree: DecisionTreeData;
    costTable: CostTableData;
    constantSet?: ConstantSet;
    growthRateList: GrowthRate[];
    growthRateId: GrowthRate;
    rateType: RateType;
    situationPlan: string;
    recalculate: boolean;
    headMilestone: number;
    tailMilestone: number;
    segmentLength: number;
    headYear: number;
    tailYear: number;
    lanes: number[];
    requestedYears: number;
    processedYears: number;
    planHorizon: number;
    messages: string;
    status: PlanStatus;
    trafficGrowthRate: number;
    plantype: PlanType;
    project: ProjectData;
    budgetLimit: BudgetLimit;
    direction: Direction;
    directions: Direction[];
    allYears: number[];
    items: IndexCrossingItemPlanData[];
    indexCrossingGroupOperator: BooleanOperators;
    updatedDependencies: string[];
    selectItem: boolean;
    updated: boolean;
    updatedAt: Date;
    roadSegments: string[];
    conditions: string;
    allMilestones: number[];
    iriCount: number;
    iggCount: number;
    fwdCount: number;
    trCount: number;
    ifiCount: number;
    icpCount: number;
    vrdCount: number;
    hsCount: number;
    urciCount: number;
    gripCount: number;
    weighingCount: number;
    structureCount: number;
    probingCount: number;
    noiseCount: number;
    unifilarWorksCount: number;
    builtCount: number;
    testCount: number;
    satCount: number;
    headTailMilestoneIri: string;
    headTailMilestoneIgg: string;
    headTailMilestoneFwd: string;
    headTailMilestoneTr: string;
    headTailMilestoneSat: string;
    headTailMilestoneVrd: string;
    headTailMilestoneHs: string;
    headTailMilestoneIfi: string;
    headTailMilestoneIcp: string;
    headTailMilestoneUrci: string;
    headTailMilestoneGrip: string;
    headTailMilestoneWeighing: string;
    headTailMilestoneProbing: string;
    headTailMilestoneNoise: string;
    headTailMilestoneTest: string;
    headTailMilestoneUnifilarWorks: string;
    headTailMilestoneStructure: string;
    headTailMilestoneBuilt: string;
    note: string;
    authorizedUsers: Link<User>[];
    idProcessingStatus: number;
    growthRate: GrowthRate[];
}

export interface PlanResumeData extends AbstractData {
    name: string;
    versionPlan: number;
    organization: OrganizationResumeData;
    road: RoadResumeData;
    roadtype: RoadType;
    campaign: Link<Campaign>;
    decisionTree: DecisionTreeData;
    costTable: CostTableData;
    criteriaSet?: CriteriaSet;
    headMilestone: number;
    tailMilestone: number;
    segmentLength: number;
    requestedYears: number;
    processedYears: number;
    planHorizon: number;
    constantSet?: ConstantSet;
    rateType: RateType;
    situationPlan: string;
    recalculate: boolean;
    project: ProjectData;
    status: PlanStatus;
    directions: Direction[];
    direction: Direction;
    iriCount: number;
    iggCount: number;
    fwdCount: number;
    trCount: number;
    ifiCount: number;
    icpCount: number;
    vrdCount: number;
    hsCount: number;
    urciCount: number;
    gripCount: number;
    weighingCount: number;
    structureCount: number;
    probingCount: number;
    noiseCount: number;
    unifilarWorksCount: number;
    builtCount: number;
    testCount: number;
    satCount: number;
    headTailMilestoneIri: string;
    headTailMilestoneIgg: string;
    headTailMilestoneFwd: string;
    headTailMilestoneTr: string;
    headTailMilestoneSat: string;
    headTailMilestoneVrd: string;
    headTailMilestoneHs: string;
    headTailMilestoneIfi: string;
    headTailMilestoneIcp: string;
    headTailMilestoneUrci: string;
    headTailMilestoneGrip: string;
    headTailMilestoneWeighing: string;
    headTailMilestoneProbing: string;
    headTailMilestoneNoise: string;
    headTailMilestoneTest: string;
    headTailMilestoneUnifilarWorks: string;
    headTailMilestoneStructure: string;
    headTailMilestoneBuilt: string;
    note: string;
}

export interface ProjectData extends AbstractData {
    name: string;
    status: ProjectStatus;
    authorizedUsers: Link<User>[];
}

export interface PlanHistoricData extends AbstractData {
    name: string;
    idPlanHistoric: number;
    versionPlan: number;
    dtUpdate: Date;
    idDecisionTree: number;
}

export interface ProbingData extends MeasurementData {
    layer1Thickness: number;
    layer2Thickness: number;
    layer3Thickness: number;
    layer4Thickness: number;
    layer1Material: string;
    layer2Material: string;
    layer3Material: string;
    layer4Material: string;
}

export interface DecisionTreeSummaryDTO extends AbstractData {
    name: string;
}

export interface IqdCalculationSummaryDTO extends AbstractData {
    name: string;
    type: IqdType;
}

export interface PlanSummaryDTO extends AbstractData {
    name: string;
    type: PlanType;
}

export interface UserSummaryDTO extends AbstractData {
    login: string;
    name: string;
}

export interface SatData extends MeasurementData {
    lightVehicleDailyAverage: number;
    heavyVehicleDailyAverage: number;
    usaceVehicleFactor: number;
    aashtoVehicleFactor: number;
    hdmVehicleFactor: number;
}

export interface SegmentsData extends AbstractData {
    headMilestone: number;
    tailMilestone: number;
    dateConclusion: string;
    expectedSolution: string;
    workItem: string;
    startDate: string;
    endDate: string;
    comments: string;
    status: string;
}

export interface SolutionsHistoricData extends AbstractData {
    idSolutionsHistoric: number;
    idSolution: number;
    nameSolution: string;
    dtUpdate: Date;
    typeSolution: string;
    grade: number;
    metric: string;
    muxer: number;
    adder: number;
    idPlan: number;
    versionPlan: number;
}

export interface StructureData extends MeasurementData {
    layer1Material: string;
    layer1Thickness: number;
    layer2Material: string;
    layer2Thickness: number;
    layer3Material: string;
    layer3Thickness: number;
    layer4Material: string;
    layer4Thickness: number;
    pavingType: string;
}

export interface ParametersVersionsData extends AbstractData {
    name: string;
    description: string;
}

export interface SystemParametersData extends AbstractData {
    name: string;
    parametersVersions: ParametersVersions;
    kpiMetric: Metrics;
    descriptionEquation: string;
}

export interface TestData extends MeasurementData {
    density: number;
    moisture: number;
    ll: number;
    lp: number;
    ip: number;
    granulometryN4: number;
    granulometryN10: number;
    granulometryN40: number;
    granulometryN200: number;
    hrb: string;
    mct: string;
    max: number;
    hot: number;
    exp: number;
    cbr: number;
}

export interface TrData extends MeasurementData {
    fc1: number;
    fc2: number;
    fc3: number;
    pothole: number;
    sinking: number;
    others: number;
}

export interface UnifilarWorksData extends MeasurementData {
    extension: string;
    executionDate: string;
    batch: string;
    county: string;
    pathology: string;
    service: string;
    subItem: string;
    nameTPU: string;
    lengthWork: string;
    width: string;
    thickness: string;
    density: string;
    layerAmount: string;
    location: string;
    frequency: string;
    unit: string;
    area: string;
    volume: string;
    ton: string;
}

export interface UrciData extends MeasurementData {
    width: number;
    a81: string;
    m81: string;
    b81: string;
    a82: string;
    m82: string;
    b82: string;
    a83: string;
    m83: string;
    b83: string;
    a84: boolean;
    m84: boolean;
    b84: boolean;
    a85: string;
    m85: string;
    b85: string;
    a86: string;
    m86: string;
    b86: string;
    a87: string;
    m87: string;
    b87: string;
    urci: number;
}

export interface VrdData extends MeasurementData {
    vrd: number;
    classification: string;
}

export interface WeighingData extends MeasurementData {
    vehicleId: number;
    pbt: number;
    axleGroup1: number;
    axleGroup2: number;
    axleGroup3: number;
    axleGroup4: number;
    axleGroup5: number;
    axleGroup6: number;
    plate: string;
    dnitclass: string;
}

export interface WorksData extends MeasurementData {
    extension: string;
    solution: string;
    executionDate: string;
}

export interface CampaignAbstractData extends AbstractNamedData {
    code: string;
}

export interface CampaignDetailData extends CampaignAbstractData {
    headDate: Date;
    tailDate: Date;
    organization: Link<Organization>;
    authorizedUsers: Link<User>[];
    createdBy: string;
}

export interface CampaignSearchData extends CampaignAbstractData {
    organization: Link<Organization>;
    headDate: Date;
    tailDate: Date;
}

export interface CampaignSelectData extends CampaignAbstractData {
}

export interface ConstantSetData extends AbstractData {
    name: string;
    k1: number;
    k2: number;
    k3: number;
    k4: number;
    k5: number;
    k6: number;
    k7: number;
    k8: number;
    k9: number;
    k10: number;
    k11: number;
}

export interface CompositionDetailData extends AbstractData {
    materialsServices: Link<MaterialsServices>;
    thickness: number;
    applicationFee: number;
    costTableItem: CostTableItemData;
    totalValueForUnit: number;
}

export interface CostTableAbstractData extends AbstractData {
    name: string;
}

export interface CostTableData extends CostTableAbstractData {
}

export interface CostTableDetailData extends CostTableAbstractData {
    items: CostTableItemDetailData[];
}

export interface CostTableItemDetailData extends AbstractData {
    solution: Link<Solution>;
    cost: number;
    compositions: CompositionDetailData[];
    unitPriceTablesId: number;
}

export interface UnitPriceTablesData extends AbstractData {
    name: string;
    materialsServices: MaterialsServicesData[];
}

export interface CriteriaSetData extends AbstractData {
    name: string;
    paved: string;
    badLimitD0: number;
    goodLimitD0: number;
    badLimitATR: number;
    goodLimitATR: number;
    badLimitFC2: number;
    goodLimitFC2: number;
    badLimitFC3: number;
    goodLimitFC3: number;
    badLimitIGG: number;
    goodLimitIGG: number;
    badLimitIRI: number;
    goodLimitIRI: number;
    badLimitURCI: number;
    goodLimitURCI: number;
    badLimitGN: number;
    goodLimitGN: number;
    badLimitIFI: number;
    goodLimitIFI: number;
    badLimitVRD: number;
    goodLimitVRD: number;
    badLimitHS: number;
    goodLimitHS: number;
    badLimitICP: number;
    goodLimitICP: number;
    badLimitNOISE: number;
    goodLimitNOISE: number;
}

export interface GrowthRateItemDetailData extends AbstractData {
    rate: number;
    headDate: Date;
    tailDate: Date;
    createdBy: string;
    createdAt: Date;
    updatedAt: Date;
}

export interface GrowthRateAbstractData extends AbstractNamedData {
}

export interface GrowthRateData extends GrowthRateAbstractData {
    items: GrowthRateItem[];
    createdBy: string;
    createdAt: Date;
    updatedAt: Date;
    nameRate: string;
}

export interface GrowthRateSearchData extends GrowthRateAbstractData {
}

export interface RoadAccessoryData extends AbstractData {
    milestone: number;
    description: string;
    area: number;
}

export interface RoadSegmentData extends AbstractData {
    headMilestone: number;
    tailMilestone: number;
    type: RoadSegmentType;
    constantSet: Link<ConstantSet>;
    incTrafficLaneCount: number;
    incTrafficLaneWidth: number;
    incShoulderLaneWidth: number;
    incSafetyLaneWidth: number;
    decTrafficLaneCount: number;
    decTrafficLaneWidth: number;
    decShoulderLaneWidth: number;
    decSafetyLaneWidth: number;
}

export interface RoadAbstractData extends AbstractData {
    code: string;
    name: string;
    roadtype: RoadType;
}

export interface RoadAbstractExtraData extends RoadAbstractData {
    headMilestone: number;
    tailMilestone: number;
    owner: Link<Organization>;
}

export interface RoadData extends RoadAbstractData {
}

export interface RoadDetailData extends RoadAbstractExtraData {
    segments: RoadSegmentData[];
    accessories: RoadAccessoryData[];
}

export interface RoadResumeData extends RoadAbstractData {
    owner: OrganizationResumeData;
    headMilestone: number;
    tailMilestone: number;
    lanesRoad: number[];
}

export interface RoadSearchData extends RoadAbstractExtraData {
    maxLaneCount: number;
}

export interface RoadSelectData extends RoadAbstractExtraData {
    lanes: number[];
}

export interface RoadSimpleData extends RoadAbstractData {
}

export interface SolutionItemDetailData extends AbstractData {
    metric: Metrics;
    muxer: number;
    adder: number;
}

export interface SolutionAbstractData extends AbstractNamedData {
}

export interface SolutionDetailData extends SolutionAbstractData {
    type: SolutionType;
    grade: number;
    applicableSl: boolean;
    recalculateTrAge: boolean;
    applicationFee: number;
    items: SolutionItemDetailData[];
    shoulderSolution: Link<Solution>;
}

export interface AbstractNamedData extends AbstractData {
    name: string;
}

export interface Link<T> extends AbstractNamedData {
}

export interface User extends AbstractMainEntity {
    login: string;
    email: string;
    active: boolean;
    system: boolean;
    language: string;
    timezone: string;
    activationKey: string;
    resetKey: string;
    resetDate: Date;
    roles: Stream<Role>;
    persistentTokens: PersistentToken[];
    authorities: Stream<Authority>;
    passwordHash: string;
    admin: boolean;
}

export interface Role extends AbstractMainEntity {
    authorities: Stream<Authority>;
}

export interface Organization extends AbstractMainEntity, EntityWithRestrictedAccess {
    code: string;
    users: User[];
    roads: Stream<Road>;
    metricLimits: MetricLimit[];
    kartadoId: string;
}

export interface AbstractData {
    id: number;
}

export interface Road extends AbstractMainEntity {
    owner: Organization;
    code: string;
    segments: Stream<RoadSegment>;
    structures: Structure[];
    accessories: Stream<RoadAccessory>;
    roadtype: RoadType;
    kartadoName: string;
    area: number;
    headMilestone: number;
    tailMilestone: number;
    lanes: IntStream;
    accessoriesSet: RoadAccessory[];
    milestoneRange: DoubleRange;
    segmentsSet: RoadSegment[];
    structuresList: Structure[];
    lanesRoad: number[];
    maxLaneCount: number;
}

export interface Plan extends AbstractMainEntity, EntityWithRestrictedAccess {
    versionPlan: number;
    road: Road;
    campaign: Campaign;
    decisionTree: DecisionTree;
    secondaryDecisionTree: DecisionTree;
    criteriaSet?: CriteriaSet;
    evolutionModel: EvolutionModel;
    constantSet?: ConstantSet;
    growthRateId: GrowthRate;
    budgetLimit: BudgetLimit;
    rateType: RateType;
    growthRateList: GrowthRate[];
    iriCount: number;
    iggCount: number;
    fwdCount: number;
    trCount: number;
    ifiCount: number;
    icpCount: number;
    vrdCount: number;
    hsCount: number;
    urciCount: number;
    gripCount: number;
    weighingCount: number;
    structureCount: number;
    probingCount: number;
    noiseCount: number;
    unifilarWorksCount: number;
    builtCount: number;
    testCount: number;
    satCount: number;
    headTailMilestoneIri: string;
    headTailMilestoneIgg: string;
    headTailMilestoneFwd: string;
    headTailMilestoneTr: string;
    headTailMilestoneSat: string;
    headTailMilestoneVrd: string;
    headTailMilestoneHs: string;
    headTailMilestoneIfi: string;
    headTailMilestoneIcp: string;
    headTailMilestoneUrci: string;
    headTailMilestoneGrip: string;
    headTailMilestoneWeighing: string;
    headTailMilestoneProbing: string;
    headTailMilestoneNoise: string;
    headTailMilestoneTest: string;
    headTailMilestoneUnifilarWorks: string;
    headTailMilestoneStructure: string;
    headTailMilestoneBuilt: string;
    costTable: CostTable;
    planHistoricList: PlanHistoric[];
    items: IndexCrossingItemPlan[];
    headMilestone: number;
    tailMilestone: number;
    segmentLength: number;
    trafficGrowthRate: number;
    requestedYears: number;
    processedYears: number;
    planHorizon: number;
    recalculate: boolean;
    plantype: PlanType;
    status: PlanStatus;
    messages: string;
    kpis: Kpi[];
    lifespan: Lifespan[];
    segments: Segments[];
    roadtype: RoadType;
    project: Project;
    situationPlan: string;
    direction: Direction;
    indexCrossingGroupOperator: BooleanOperators;
    filterDirectionForResult: Direction;
    directions: Direction[];
    systemParameterEquationIgg: SystemParameters;
    updatedDependencies: string[];
    selectItem: boolean;
    note: string;
    conditions: string;
    organization: Organization;
    updated: boolean;
    headYear: number;
    tailYear: number;
    lanes: IntStream;
    allYears: number[];
    roadSegments: string[];
    allMilestones: number[];
    sumCostKpiAllYears: number;
}

export interface BudgetLimitItem extends AbstractMainEntity {
    limit: number;
    dateLimit: Date;
}

export interface BudgetLimit extends AbstractMainEntity {
    items: BudgetLimitItem[];
}

export interface Campaign extends AbstractMainEntity, EntityWithRestrictedAccess {
    organization: Organization;
    code: string;
    headDate: Date;
    tailDate: Date;
}

export interface Solution extends AbstractMainEntity, Consumer<Kpi>, Cloneable {
    type: SolutionType;
    grade: number;
    items: Stream<SolutionItem>;
    applicableSl: boolean;
    recalculateTrAge: boolean;
    applicationFee: number;
    shoulderSolution: Solution;
    percentApplicationFee: number;
    thereShoulderSolution: boolean;
}

export interface DecisionTree extends AbstractMainEntity, Function<Kpi, Stream<Solution>> {
    items: Stream<DecisionTreeItem>;
    project: Project;
    situation: DecisionTreeSituation;
    possibleSolutions: Stream<Solution>;
    root: DecisionTreeItem;
}

export interface Project extends AbstractMainEntity, EntityWithRestrictedAccess {
    status: ProjectStatus;
}

export interface ConstantSet extends AbstractMainEntity {
    k1: number;
    k2: number;
    k3: number;
    k4: number;
    k5: number;
    k6: number;
    k7: number;
    k8: number;
    k9: number;
    k10: number;
    k11: number;
}

export interface GrowthRate extends AbstractMainEntity {
    items: GrowthRateItem[];
}

export interface CriteriaSet extends AbstractMainEntity {
    paved: string;
    badLimitD0: number;
    goodLimitD0: number;
    badLimitATR: number;
    goodLimitATR: number;
    badLimitFC2: number;
    goodLimitFC2: number;
    badLimitFC3: number;
    goodLimitFC3: number;
    badLimitIGG: number;
    goodLimitIGG: number;
    badLimitIRI: number;
    goodLimitIRI: number;
    badLimitURCI: number;
    goodLimitURCI: number;
    badLimitGN: number;
    goodLimitGN: number;
    badLimitIFI: number;
    goodLimitIFI: number;
    badLimitVRD: number;
    goodLimitVRD: number;
    badLimitHS: number;
    goodLimitHS: number;
    badLimitICP: number;
    goodLimitICP: number;
    badLimitNOISE: number;
    goodLimitNOISE: number;
}

export interface ParametersVersions extends AbstractMainEntity {
    description: string;
}

export interface MaterialsServices extends AbstractMainEntity {
    unit: Units;
    value: number;
    unitPriceTable: UnitPriceTables;
    idUnitPriceTable: number;
}

export interface CostTableItemData {
    id: number;
}

export interface GrowthRateItem extends AbstractMainEntity {
    headDate: Date;
    tailDate: Date;
    rate: number;
    owner: number;
}

export interface AuditEvent {
    timestamp: Date;
    principal: string;
    type: string;
    data: { [index: string]: any };
}

export interface PasswordData {
    key: string;
    newPassword: string;
}

export interface MetricRankedData {
    goodArea: number;
    borderlineArea: number;
    badArea: number;
    inactiveArea: number;
}

export interface MeasurementsData extends AbstractEnumData {
    type: MeasurementFormat;
}

export interface MetricsData extends AbstractEnumData {
    measurement: string;
    unit: Units;
    precision: number;
    factor: number;
    view: string;
    full: string;
}

export interface ParameterEvolutionChartQuery {
    metric: string;
    direction: string;
    lanes: number[];
    milestones: number[];
}

export interface ParameterEvolutionChartData {
    yearlyData: YearlyComparisonEntry[];
    comparisonPoints: ComparisonPointData[];
    rmse: number;
}

export interface PlansDataSize {
    size: number;
}

export interface StreamingResponseBody {
}

export interface MaterialsServicesResultData {
    columns: MaterialsServicesColumnData[];
    rows: MaterialsServicesRowData[];
    budgetTotal: number;
}

export interface ProjectDependenciesDTO {
    plans: PlanSummaryDTO[];
    decisionTrees: DecisionTreeSummaryDTO[];
    authorizedUsers: UserSummaryDTO[];
    iqdCalculations: IqdCalculationSummaryDTO[];
}

export interface RoadDependenciesDTO {
    plans: PlanSummaryDTO[];
    parameterEvolutions: ParameterEvolutionSummaryDTO[];
    measurementCounts: MeasurementCountDTO[];
}

export interface LoggerVM {
    name: string;
    level: string;
}

export interface Stream<T> extends BaseStream<T, Stream<T>> {
}

export interface PersistentToken {
    series: string;
    ipAddress: string;
    userAgent: string;
    formattedTokenDate: string;
}

export interface AbstractMainEntity extends AbstractEntity {
    createdBy: string;
    createdAt: Date;
    updatedBy: string;
    updatedAt: Date;
}

export interface MetricLimit extends AbstractMainEntity {
    organization: Organization;
    metric: Metrics;
    goodLimit: number;
    badLimit: number;
    maxLimit: number;
    minLimit: number;
    measurement: Measurements;
}

export interface EntityWithRestrictedAccess {
    authorizedUsers: User[];
}

export interface RoadSegment extends AbstractWeakEntity<Road> {
    owner: Road;
    headMilestone: number;
    tailMilestone: number;
    type: RoadSegmentType;
    constantSet: ConstantSet;
    road: Road;
    incTrafficLaneCount: number;
    incTrafficLaneWidth: number;
    incShoulderLaneWidth: number;
    decTrafficLaneCount: number;
    decTrafficLaneWidth: number;
    decShoulderLaneWidth: number;
    decSafetyLaneWidth: number;
    incSafetyLaneWidth: number;
    area: number;
    lanes: IntStream;
    milestoneRange: DoubleRange;
    decRoadWay: RoadWay;
    incRoadWay: RoadWay;
    maxTrafficLaneCount: number;
    length: number;
}

export interface Structure extends Measurement {
    layer1Thickness: number;
    layer2Thickness: number;
    layer3Thickness: number;
    layer4Thickness: number;
    layer1Material: string;
    layer2Material: string;
    layer3Material: string;
    layer4Material: string;
    pavingType: string;
}

export interface RoadAccessory extends AbstractWeakEntity<Road> {
    owner: Road;
    milestone: number;
    description: string;
    area: number;
    road: Road;
}

export interface IntStream extends BaseStream<number, IntStream> {
}

export interface DoubleRange {
    lower: number;
    upper: number;
    length: number;
    empty: boolean;
    finite: boolean;
}

export interface EvolutionModel {
}

export interface CostTable extends AbstractMainEntity {
    items: Stream<CostTableItem>;
}

export interface PlanHistoric {
    idPlanHistoric: number;
    versionPlan: number;
    dtUpdate: Date;
    name: string;
    idDecisionTree: number;
    parent: Plan;
}

export interface IndexCrossingItemPlan extends AbstractEntity {
    operator: LogicalOperators;
    lhsMetric: Metrics;
    lhsValue: number;
    rhsMetric: Metrics;
    rhsValue: number;
    ownerPlan: Plan;
    dtype: DecisionTreeNodeItemType;
}

export interface Kpi extends AbstractEntity, Cloneable {
    plan: Plan;
    parameterEvolution: ParameterEvolution;
    consideredCampaign: Campaign;
    presentMeasurements: Measurements[];
    missingMeasurements: Measurements[];
    materialsServices: string[];
    year: number;
    age: number;
    interventionYear: number;
    interventionAge: number;
    headMilestone: number;
    tailMilestone: number;
    constantSet: ConstantSet;
    direction: Direction;
    lane: number;
    area: number;
    areaWithoutSafetyArea: number;
    solutions: Stream<Solution>;
    cost: number;
    snc: number;
    noise: number;
    ifi: number;
    vrd: number;
    gn: number;
    d0: number;
    urci: number;
    fc2: number;
    fc3: number;
    dadm: number;
    hs: number;
    d120: number;
    radius: number;
    qi: number;
    iri: number;
    igg: number;
    arrow: number;
    tr: number;
    trAge: number;
    icp: number;
    heavyVehicleDailyAverage: number;
    usaceVehicleFactor: number;
    aashtoVehicleFactor: number;
    usaceNumber: number;
    aashtoYearNumber: number;
    indexCrossing: boolean;
    atr: number;
    beforeCost: number;
    beforeSnc: number;
    beforeNoise: number;
    beforeIfi: number;
    beforeVrd: number;
    beforeGn: number;
    beforeD0: number;
    beforeUrci: number;
    beforeFc2: number;
    beforeFc3: number;
    beforeDadm: number;
    beforeHs: number;
    beforeD120: number;
    beforeRadius: number;
    beforeQi: number;
    beforeIri: number;
    beforeIgg: number;
    beforeArrow: number;
    beforeTr: number;
    beforeTrAge: number;
    beforeHeavyVehicleDailyAverage: number;
    beforeUsaceVehicleFactor: number;
    beforeAashtoVehicleFactor: number;
    beforeUsaceNumber: number;
    beforeAashtoYearNumber: number;
    beforeIcp: number;
    beforeAtr: number;
    beforeDc: number;
    conditions: string;
    addSolutions: boolean;
    roadwayType: RoadSegmentType;
    directionAsDouble: number;
    hrPro011: number;
    hrPro159: number;
    dc: number;
    hrPro269: number;
    beforeHrPro011: number;
    beforeHrPro269: number;
    beforeHrPro159: number;
    sumCostForYear: number;
    shoulder: boolean;
    solvable: boolean;
    roadAsDouble: number;
    laneAsDouble: number;
    yearAsDouble: number;
    crackingYear: number;
    solutionsList: Solution[];
    setSolutions: Solution[];
    gradeIndex: string;
    interventionAreaWithoutSafetyArea: number;
    grade: number;
    sumCostKpiAllYears: number;
    interventionArea: number;
}

export interface Lifespan extends AbstractEntity {
    plan: Plan;
    headMilestone: number;
    tailMilestone: number;
    direction: Direction;
    lane: number;
    firstAgeDcIntervention: number;
    firstAgeQiIntervention: number;
    firstAgeIggIntervention: number;
    firstAgeArrowIntervention: number;
    firstAgeTrIntervention: number;
    minimum: number;
}

export interface Segments extends AbstractEntity {
    plan: Plan;
    headMilestone: number;
    tailMilestone: number;
    dateConclusion: string;
    expectedSolution: string;
    workItem: string;
    startDate: string;
    endDate: string;
    comments: string;
    status: string;
}

export interface SystemParameters extends AbstractMainEntity {
    parametersVersions: ParametersVersions;
    kpiMetric: Metrics;
    descriptionEquation: string;
}

export interface SolutionItem extends AbstractWeakEntity<Solution>, Consumer<Kpi> {
    owner: Solution;
    metric: Metrics;
    muxer: number;
    adder: number;
}

export interface Cloneable {
}

export interface DecisionTreeItem extends AbstractWeakEntity<DecisionTree>, Function<Kpi, Stream<Solution>> {
    owner: DecisionTree;
    root: boolean;
    possibleSubtrees: Stream<DecisionTree>;
    possibleSolutions: Stream<Solution>;
}

export interface UnitPriceTables extends AbstractMainEntity {
    materialsServices: MaterialsServices[];
}

export interface Page<T> extends Slice<T> {
    totalElements: number;
    totalPages: number;
}

export interface OrganizationSummaryDTO {
    code: string;
    name: string;
    id: number;
}

export interface AuditLogData {
    id: number;
    userName: string;
    module: string;
    entityName: string;
    operation: string;
    operationDate: Date;
}

export interface ImportErrorData {
    rowsNumber: string;
    errorCode: string;
    params: { [index: string]: any };
    message: string;
}

export interface ImportHistory {
    id: number;
    fileName: string;
    planId: number;
    startDate: Date;
    lastUpdateDate: Date;
    endDate: Date;
    hasErrors: boolean;
    fileSizeKb: number;
    totalLines: number;
    importedLines: number;
    idProcessingStatus: number;
    status: ImportStatus;
    importType: ImportType;
    lastProcessedRoadIndex: number;
    lastProcessedPage: number;
    lastProcessedRoadName: string;
}

export interface AbstractEnumData {
    name: string;
    code: string;
}

export interface Iterable<T> {
}

export interface YearlyComparisonEntry {
    year: number;
    projectedValue: number;
    measuredValue: number;
    error: number;
}

export interface ComparisonPointData {
    year: number;
    campaignName: string;
    campaignId: number;
    metricValue: number;
}

export interface ItemKpiMaterialsServiceData {
    year: number;
    name: string;
    unit: Units;
    valueSum: number;
}

export interface MaterialsServicesColumnData {
    year: number;
    direction: Direction;
    lane: number;
    shoulder: boolean;
}

export interface MaterialsServicesRowData {
    number: number;
    unitPriceTable: string;
    name: string;
    unit: Units;
    unitValue: number;
    quantities: number[];
    quantityTotal: number;
    budget: number;
}

export interface MetricOverviewData {
    metric: Metrics;
    type: PlanOverviewItemType;
    goodLimit: number;
    badLimit: number;
    items: MetricOverviewItemData[];
}

export interface IdNameDto {
    id: number;
    name: string;
}

export interface ParameterEvolutionSummaryDTO {
    id: number;
    name: string;
}

export interface MeasurementCountDTO {
    type: string;
    count: number;
}

export interface RoadSummaryDTO {
    code: string;
    name: string;
    id: number;
}

export interface AbstractEntity {
    id: number;
    uid: string;
    name: string;
}

export interface RoadWay extends AbstractWeakEntity<RoadSegment> {
    owner: RoadSegment;
    direction: Direction;
    trafficLaneCount: number;
    trafficLaneWidth: number;
    shoulderLaneWidth: number;
    safetyLaneWidth: number;
    width: number;
    lanes: IntStream;
}

export interface Geometry<P> {
    positions: PositionSequence<P>;
    coordinateDimension: number;
    coordinateReferenceSystem: CoordinateReferenceSystem<P>;
    positionClass: Class<P>;
    srid: number;
    numPositions: number;
    envelope: Envelope<P>;
    dimension: number;
    geometryType: GeometryType;
    empty: boolean;
}

export interface G3D extends G2D {
    height: number;
}

export interface Measurement extends AbstractMainEntity {
    road: Road;
    campaign: Campaign;
    direction: Direction;
    lane: number;
    headMilestone: number;
    tailMilestone: number;
    position: Geometry<G3D>;
    dateTime: Date;
    markerKilometer: number;
    comments: string;
    organization: Organization;
    complete: boolean;
    milestone: number;
    milestoneRange: DoubleRange;
    length: number;
    empty: boolean;
    valid: boolean;
}

export interface CostTableItem extends AbstractEntity {
    costTable: CostTable;
    solution: Solution;
    cost: number;
    compositions: Composition[];
    unitPriceTablesId: number;
    materialsServicesString: string;
    items: Stream<Composition>;
}

export interface ParameterEvolution extends AbstractMainEntity {
    road: Road;
    campaign: Campaign;
    constantSet: ConstantSet;
    growthRate: GrowthRate;
    rateType: RateType;
    headMilestone: number;
    tailMilestone: number;
    segmentLength: number;
    trafficGrowthRate: number;
    requestedYears: number;
    consideredCampaigns: Campaign[];
}

export interface Consumer<T> {
}

export interface Function<T, R> {
}

export interface Pageable {
    paged: boolean;
    pageSize: number;
    pageNumber: number;
    unpaged: boolean;
    offset: number;
    sort: Sort;
}

export interface Sort extends Streamable<Order> {
    sorted: boolean;
    unsorted: boolean;
}

export interface MetricOverviewItemData {
    year: number;
    average: number;
    sum: number;
    ranked: MetricRankedData;
}

export interface BaseStream<T, S> extends AutoCloseable {
    parallel: boolean;
}

export interface AbstractWeakEntity<T> extends AbstractEntity {
    owner: T;
}

export interface PositionSequence<P> extends Iterable<P> {
    coordinateDimension: number;
    positionClass: Class<P>;
    positionFactory: PositionFactory<P>;
    empty: boolean;
}

export interface CoordinateReferenceSystem<P> extends CrsIdentifiable {
    coordinateSystem: CoordinateSystem<P>;
    coordinateDimension: number;
    positionClass: Class<P>;
    compound: boolean;
}

export interface Class<T> extends GenericDeclaration, Type, AnnotatedElement {
}

export interface Envelope<P> {
    coordinateReferenceSystem: CoordinateReferenceSystem<P>;
    empty: boolean;
}

export interface G2D extends Position {
    lon: number;
    lat: number;
}

export interface Composition extends AbstractEntity {
    materialsServices: MaterialsServices;
    thickness: number;
    applicationFee: number;
    createdBy: string;
    createdAt: Date;
    updatedBy: string;
    updatedAt: Date;
    costTableItem: CostTableItem;
}

export interface Slice<T> extends Streamable<T> {
    first: boolean;
    last: boolean;
    pageable: Pageable;
    numberOfElements: number;
    number: number;
    size: number;
    content: T[];
    sort: Sort;
}

export interface AutoCloseable {
}

export interface PositionFactory<P> {
    coordinateDimension: number;
    mcomponentIndex: number;
}

export interface CrsId {
    authority: string;
    code: number;
}

export interface CoordinateSystem<P> {
    axes: CoordinateSystemAxis[];
    coordinateDimension: number;
    positionClass: Class<P>;
    axisDirections: CoordinateSystemAxisDirection[];
    axisNormalOrder: number[];
}

export interface CrsIdentifiable {
    crsId: CrsId;
    name: string;
}

export interface GenericDeclaration extends AnnotatedElement {
    typeParameters: TypeVariable<any>[];
}

export interface Type {
    typeName: string;
}

export interface AnnotatedElement {
    annotations: Annotation[];
    declaredAnnotations: Annotation[];
}

export interface Position {
    coordinateDimension: number;
    empty: boolean;
}

export interface Streamable<T> extends Iterable<T>, Supplier<Stream<T>> {
    empty: boolean;
}

export interface Order {
    direction: SortDirection;
    property: string;
    ignoreCase: boolean;
    nullHandling: NullHandling;
    ascending: boolean;
    descending: boolean;
}

export interface CoordinateSystemAxis {
    axisName: string;
    unit: Unit;
    normalOrder: number;
    axisDirection: CoordinateSystemAxisDirection;
}

export interface TypeVariable<D> extends Type, AnnotatedElement {
    bounds: Type[];
    genericDeclaration: D;
    annotatedBounds: AnnotatedType[];
    name: string;
}

export interface Annotation {
}

export interface Unit extends CrsIdentifiable {
    conversionFactor: number;
    fundamentalUnit: Unit;
    angular: boolean;
}

export interface AnnotatedType extends AnnotatedElement {
    annotatedOwnerType: AnnotatedType;
    type: Type;
}

export interface Supplier<T> {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class UserResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/users
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.create
     */
    create(detail: UserDetailData, options?: O): RestResponse<UserDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/users`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/users
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.query
     */
    query(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<UserSearchData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/users`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/users/all
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.queryAll
     */
    queryAll(queryParams?: { query?: string; }, options?: O): RestResponse<Link<User>[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/users/all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/users/current
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.getAccount
     */
    getAccount(options?: O): RestResponse<UserDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/users/current`, options: options });
    }

    /**
     * HTTP DELETE /api/users/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/users/${id}`, options: options });
    }

    /**
     * HTTP GET /api/users/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.get
     */
    get(id: number, options?: O): RestResponse<UserDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/users/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/users/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.put
     */
    put(id: number, detail: UserDetailData, options?: O): RestResponse<UserDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/users/${id}`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/users/{id}/active
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.getActive
     */
    getActive(id: number, options?: O): RestResponse<boolean> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/users/${id}/active`, options: options });
    }

    /**
     * HTTP PUT /api/users/{id}/active
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.UserResource.setActive
     */
    setActive(id: number, active: boolean, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/users/${id}/active`, data: active, options: options });
    }
}

export class UrciResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/urcis
     * Java method: br.com.rrunner.pavrunner.domain.data.urci.UrciResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/urcis`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/urcis
     * Java method: br.com.rrunner.pavrunner.domain.data.urci.UrciResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<UrciData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/urcis`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/urcis/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.urci.UrciResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/urcis/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/urcis/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.urci.UrciResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/urcis/ranked`, queryParams: queryParams, options: options });
    }
}

export class IqdCalculationResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/iqd-calculation
     * Java method: br.com.rrunner.pavrunner.domain.data.iqdCalculation.IqdCalculationResource.create
     */
    create(vm: IqdCalculationData, options?: O): RestResponse<IqdCalculationData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/iqd-calculation`, data: vm, options: options });
    }

    /**
     * HTTP GET /api/iqd-calculation
     * Java method: br.com.rrunner.pavrunner.domain.data.iqdCalculation.IqdCalculationResource.select
     */
    select(queryParams: { iqdtype: IqdType; project?: number; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<IqdCalculationData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iqd-calculation`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/iqd-calculation/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.iqdCalculation.IqdCalculationResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/iqd-calculation/${id}`, options: options });
    }

    /**
     * HTTP GET /api/iqd-calculation/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.iqdCalculation.IqdCalculationResource.get
     */
    get(id: number, options?: O): RestResponse<IqdCalculationData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iqd-calculation/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/iqd-calculation/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.iqdCalculation.IqdCalculationResource.update
     */
    update(id: number, detail: IqdCalculationData, options?: O): RestResponse<IqdCalculationData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/iqd-calculation/${id}`, data: detail, options: options });
    }
}

export class MechanicalAnalysisResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/mechanical-analysis
     * Java method: br.com.rrunner.pavrunner.domain.data.mechanicalAnalysis.MechanicalAnalysisResource.calculate
     */
    calculate(obj: MechanicalAnalysisData, options?: O): RestResponse<MechanicalAnalysisData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/mechanical-analysis`, data: obj, options: options });
    }
}

export class PlanResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/plans
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.create
     */
    create$POST$api_plans(detail: PlanData, options?: O): RestResponse<PlanData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/plans`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/plans
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.query
     */
    query(queryParams: { query?: string; organization?: number; road?: number; campaign?: number; plantype: PlanType; roadtype?: RoadType; project?: number; situationPlan?: string; plans?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<{ [index: string]: any }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/RemoveDuplicatedMeasurements
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.removeDuplicatedMeasurements
     */
    removeDuplicatedMeasurements(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/RemoveDuplicatedMeasurements`, options: options });
    }

    /**
     * HTTP GET /api/plans/UpdatedDependencies
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.getUpdatedDependencies
     */
    getUpdatedDependencies(queryParams: { planId: number; }, options?: O): RestResponse<PlanData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/UpdatedDependencies`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /api/plans/batch-delete
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.deleteBatch
     */
    deleteBatch(ids: number[], options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/plans/batch-delete`, data: ids, options: options });
    }

    /**
     * HTTP GET /api/plans/campaignCount/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.findByCount
     */
    findByCount(id: number, options?: O): RestResponse<number> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/campaignCount/${id}`, options: options });
    }

    /**
     * HTTP GET /api/plans/campaigns
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryCampaigns
     */
    queryCampaigns(options?: O): RestResponse<CampaignDetailData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/campaigns`, options: options });
    }

    /**
     * HTTP POST /api/plans/duplicate/plansForProject
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.create
     */
    create$POST$api_plans_duplicate_plansForProject(project: ProjectData, options?: O): RestResponse<PlansDataSize> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/plans/duplicate/plansForProject`, data: project, options: options });
    }

    /**
     * HTTP GET /api/plans/exportGapIdentification
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelGapIdentificationFile
     */
    downloadExcelGapIdentificationFile(queryParams: { planId: number; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/exportGapIdentification`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/exportSegments
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelSegmentsFile
     */
    downloadExcelSegmentsFile(queryParams: { planId: number; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/exportSegments`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/materialservicesummaries/{planId}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.getMaterialServiceSummaries
     */
    getMaterialServiceSummaries(planId: number, options?: O): RestResponse<ItemKpiMaterialsServiceData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/materialservicesummaries/${planId}`, options: options });
    }

    /**
     * HTTP GET /api/plans/plans/results
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryPlansResults
     */
    queryPlansResults(queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<KpiData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/plans/results`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/plansId
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryForIds
     */
    queryForIds(queryParams?: { plansId?: number[]; }, options?: O): RestResponse<PlanData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/plansId`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/status
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.getStatus
     */
    getStatus(queryParams?: { search?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<StatusProcessEntityData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/status`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/ensaios
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateEnsaios
     */
    downloadTemplateEnsaios(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/ensaios`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/estrutura
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateEstrutura
     */
    downloadTemplateEstrutura(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/estrutura`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/fwd
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateFWD
     */
    downloadTemplateFWD(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/fwd`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/gn
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateGN
     */
    downloadTemplateGN(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/gn`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/hs
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateOnlyHS
     */
    downloadTemplateOnlyHS(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/hs`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/icp
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateICP
     */
    downloadTemplateICP(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/icp`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/ifi
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateIFI
     */
    downloadTemplateIFI(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/ifi`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/igg
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateIGG
     */
    downloadTemplateIGG(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/igg`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/iri
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateIRI
     */
    downloadTemplateIRI(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/iri`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/obras-executadas
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateObrasExecutadas
     */
    downloadTemplateObrasExecutadas(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/obras-executadas`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/pesagem
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplatePesagem
     */
    downloadTemplatePesagem(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/pesagem`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/ruido
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateRuido
     */
    downloadTemplateRuido(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/ruido`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/sondagem
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateSondagem
     */
    downloadTemplateSondagem(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/sondagem`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/tr
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateTR
     */
    downloadTemplateTR(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/tr`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/trafego
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateTrafego
     */
    downloadTemplateTrafego(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/trafego`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/unifilar-obras
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateUnifilarObras
     */
    downloadTemplateUnifilarObras(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/unifilar-obras`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/urci
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateURCI
     */
    downloadTemplateURCI(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/urci`, options: options });
    }

    /**
     * HTTP GET /api/plans/templates/vrd
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadTemplateVRD
     */
    downloadTemplateVRD(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/templates/vrd`, options: options });
    }

    /**
     * HTTP DELETE /api/plans/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/plans/${id}`, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.get
     */
    get(id: number, options?: O): RestResponse<PlanData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/plans/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.update
     */
    update$PUT$api_plans_id(id: number, detail: PlanData, options?: O): RestResponse<PlanData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/plans/${id}`, data: detail, options: options });
    }

    /**
     * HTTP PATCH /api/plans/{id}/note
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.updateNote
     */
    updateNote(id: number, note: string, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "PATCH", url: uriEncoding`api/plans/${id}/note`, data: note, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/queryByFilterForPlans
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryByFilterForPlans
     */
    queryByFilterForPlans(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<KpiData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/queryByFilterForPlans`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/queryByFilterForSegments
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryByFilterForSegments
     */
    queryByFilterForSegments(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<SegmentsData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/queryByFilterForSegments`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryResults
     */
    queryResults$GET$api_plans_id_results(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; metric?: string; materialsServices?: boolean; }, options?: O): RestResponse<{ [index: string]: any }[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/P21/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelP21
     */
    downloadExcelP21(id: number, queryParams?: { direction?: Direction; campaign?: string; road?: string; lanes?: number[]; metric?: Metrics; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/P21/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcel
     */
    downloadExcel(id: number, queryParams?: { direction?: Direction; lanes?: number[]; metric?: Metrics; reportName?: string; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/full/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelFullKPI
     */
    downloadExcelFullKPI(id: number, queryParams?: { direction?: Direction; lanes?: number[]; metric?: Metrics; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/full/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/lifespan
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryResultsLifespan
     */
    queryResultsLifespan(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; }, options?: O): RestResponse<LifespanData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/lifespan`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/lifespan/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelLifespan
     */
    downloadExcelLifespan(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; }, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/lifespan/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/materialsservices
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryResultsMaterialsServices
     */
    queryResultsMaterialsServices(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; headYear?: number; tailYear?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MaterialsServicesResultData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/materialsservices`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/results/materialsservices/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.downloadExcelMaterialsServices
     */
    downloadExcelMaterialsServices(id: number, options?: O): RestResponse<StreamingResponseBody> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/results/materialsservices/excel`, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/resultsChartLine
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryResults
     */
    queryResults$GET$api_plans_id_resultsChartLine(id: number, queryParams?: { direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; milestones?: number[]; }, options?: O): RestResponse<KpiData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/resultsChartLine`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/resultsSegments
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.queryResultsSegments
     */
    queryResultsSegments(id: number, queryParams?: { headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; headYear?: number; tailYear?: number; plans?: number[]; }, options?: O): RestResponse<SegmentsData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/resultsSegments`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/segments
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.querySegments
     */
    querySegments$GET$api_plans_id_segments(id: number, options?: O): RestResponse<SegmentsData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/segments`, options: options });
    }

    /**
     * HTTP PUT /api/plans/{id}/segments
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.update
     */
    update$PUT$api_plans_id_segments(id: number, segments: SegmentsData[], options?: O): RestResponse<SegmentsData[]> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/plans/${id}/segments`, data: segments, options: options });
    }

    /**
     * HTTP GET /api/plans/{id}/segmentsOrdered
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.querySegments
     */
    querySegments$GET$api_plans_id_segmentsOrdered(id: number, options?: O): RestResponse<SegmentsData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${id}/segmentsOrdered`, options: options });
    }

    /**
     * HTTP GET /api/plans/{planId}/overviews/{overviewId}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.PlanResource.querySummary
     */
    querySummary(planId: number, overviewId: number, options?: O): RestResponse<MetricOverviewData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans/${planId}/overviews/${overviewId}`, options: options });
    }
}

export class MaterialsServicesResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/materialsServices
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.create
     */
    create(detail: MaterialsServicesData, options?: O): RestResponse<MaterialsServicesData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/materialsServices`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/materialsServices
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.query
     */
    query(queryParams?: { name?: string; unit?: Units; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<MaterialsServicesData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/materialsServices`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP PUT /api/materialsServices
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.update
     */
    update(detail: MaterialsServicesData, options?: O): RestResponse<MaterialsServicesData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/materialsServices`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/materialsServices/unitPriceTable/{idUnitPriceTable}
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.getByIdUnitPriceTable
     */
    getByIdUnitPriceTable(idUnitPriceTable: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<MaterialsServicesData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/materialsServices/unitPriceTable/${idUnitPriceTable}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/materialsServices/units
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.getUnits
     */
    getUnits(options?: O): RestResponse<Units[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/materialsServices/units`, options: options });
    }

    /**
     * HTTP DELETE /api/materialsServices/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/materialsServices/${id}`, options: options });
    }

    /**
     * HTTP GET /api/materialsServices/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.get
     */
    get(id: number, options?: O): RestResponse<MaterialsServicesData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/materialsServices/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/materialsServices/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.matrialsservices.MaterialsServicesResource.put
     */
    put(id: number, detail: MaterialsServicesData, options?: O): RestResponse<MaterialsServicesData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/materialsServices/${id}`, data: detail, options: options });
    }
}

export class UnifilarWorksResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/unifilarWorkss
     * Java method: br.com.rrunner.pavrunner.domain.data.unifilarWorks.UnifilarWorksResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/unifilarWorkss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/unifilarWorkss
     * Java method: br.com.rrunner.pavrunner.domain.data.unifilarWorks.UnifilarWorksResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<UnifilarWorksData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unifilarWorkss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/unifilarWorkss/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.unifilarWorks.UnifilarWorksResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unifilarWorkss/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/unifilarWorkss/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.unifilarWorks.UnifilarWorksResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unifilarWorkss/ranked`, queryParams: queryParams, options: options });
    }
}

export class AccountResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/account
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.getAccount
     */
    getAccount(options?: O): RestResponse<UserDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/account`, options: options });
    }

    /**
     * HTTP POST /api/account
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.saveAccount
     */
    saveAccount(vm: UserDetailData, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/account`, data: vm, options: options });
    }

    /**
     * HTTP POST /api/account/change_password
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.changePassword
     */
    changePassword(password: string, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/account/change_password`, data: password, options: options });
    }

    /**
     * HTTP POST /api/account/reset-password/finish
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.finishPasswordReset
     */
    finishPasswordReset(vm: PasswordData, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/account/reset-password/finish`, data: vm, options: options });
    }

    /**
     * HTTP POST /api/account/reset-password/init
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.requestPasswordReset
     */
    requestPasswordReset(mail: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/account/reset-password/init`, data: mail, options: options });
    }

    /**
     * HTTP GET /api/account/sessions
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.getCurrentSessions
     */
    getCurrentSessions(options?: O): RestResponse<PersistentToken[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/account/sessions`, options: options });
    }

    /**
     * HTTP DELETE /api/account/sessions/{series}
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.invalidateSession
     */
    invalidateSession(series: string, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/account/sessions/${series}`, options: options });
    }

    /**
     * HTTP GET /api/activate
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.activateAccount
     */
    activateAccount(queryParams: { key: string; }, options?: O): RestResponse<User> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/activate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/authenticate
     * Java method: br.com.rrunner.pavrunner.domain.admin.user.AccountResource.isAuthenticated
     */
    isAuthenticated(options?: O): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/authenticate`, options: options });
    }
}

export class CampaignResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/campaigns
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.create
     */
    create(detail: CampaignDetailData, options?: O): RestResponse<CampaignDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/campaigns`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/campaigns
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.query
     */
    query(queryParams?: { query?: string; empty?: boolean; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<CampaignDetailData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/campaigns/campaignCountIgg/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.findByCountIgg
     */
    findByCountIgg(id: string, options?: O): RestResponse<number> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/campaignCountIgg/${id}`, options: options });
    }

    /**
     * HTTP GET /api/campaigns/campaignCountIri/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.findByCountIri
     */
    findByCountIri$GET$api_campaigns_campaignCountIri_id(id: string, options?: O): RestResponse<number> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/campaignCountIri/${id}`, options: options });
    }

    /**
     * HTTP GET /api/campaigns/campaignCountIriOrdened
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.findByCountIri
     */
    findByCountIri$GET$api_campaigns_campaignCountIriOrdened(options?: O): RestResponse<number[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/campaignCountIriOrdened`, options: options });
    }

    /**
     * HTTP GET /api/campaigns/campaigns
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.queryCampaigns
     */
    queryCampaigns(options?: O): RestResponse<CampaignDetailData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/campaigns`, options: options });
    }

    /**
     * HTTP GET /api/campaigns/results/bd_monitoracao/excel/{idCampaign}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.downloadExcelBdMonitoramento
     */
    downloadExcelBdMonitoramento(idCampaign: number, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/results/bd_monitoracao/excel/${idCampaign}`, options: options });
    }

    /**
     * HTTP DELETE /api/campaigns/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/campaigns/${id}`, options: options });
    }

    /**
     * HTTP GET /api/campaigns/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.get
     */
    get(id: number, options?: O): RestResponse<CampaignDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/campaigns/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/campaigns/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.campaign.CampaignResource.put
     */
    put(id: number, detail: CampaignDetailData, options?: O): RestResponse<CampaignDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/campaigns/${id}`, data: detail, options: options });
    }
}

export class ParameterEvolutionResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/parameterEvolutions
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.create
     */
    create(data: ParameterEvolutionData, options?: O): RestResponse<ParameterEvolutionData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/parameterEvolutions`, data: data, options: options });
    }

    /**
     * HTTP GET /api/parameterEvolutions
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.query
     */
    query(queryParams?: { organizationId?: number; roadId?: number; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ParameterEvolutionData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/parameterEvolutions`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/parameterEvolutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/parameterEvolutions/${id}`, options: options });
    }

    /**
     * HTTP GET /api/parameterEvolutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.findById
     */
    findById(id: number, options?: O): RestResponse<ParameterEvolutionData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/parameterEvolutions/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/parameterEvolutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.update
     */
    update(id: number, data: ParameterEvolutionData, options?: O): RestResponse<ParameterEvolutionData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/parameterEvolutions/${id}`, data: data, options: options });
    }

    /**
     * HTTP POST /api/parameterEvolutions/{id}/chartData
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.chartData
     */
    chartData(id: number, query: ParameterEvolutionChartQuery, options?: O): RestResponse<ParameterEvolutionChartData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/parameterEvolutions/${id}/chartData`, data: query, options: options });
    }

    /**
     * HTTP GET /api/parameterEvolutions/{id}/processingStatus
     * Java method: br.com.rrunner.pavrunner.domain.data.parameterEvolution.ParameterEvolutionResource.processingStatus
     */
    processingStatus(id: number, options?: O): RestResponse<ParameterEvolutionProcessingStatus> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/parameterEvolutions/${id}/processingStatus`, options: options });
    }
}

export class IcpResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/icps
     * Java method: br.com.rrunner.pavrunner.domain.data.icp.IcpResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/icps`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/icps
     * Java method: br.com.rrunner.pavrunner.domain.data.icp.IcpResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<IcpData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/icps`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/icps/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.icp.IcpResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/icps/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/icps/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.icp.IcpResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/icps/ranked`, queryParams: queryParams, options: options });
    }
}

export class BuiltResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/builts
     * Java method: br.com.rrunner.pavrunner.domain.data.built.BuiltResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; startDate?: Date; endDate?: Date; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/builts`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/builts
     * Java method: br.com.rrunner.pavrunner.domain.data.built.BuiltResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; startDate?: Date; endDate?: Date; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<BuiltData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/builts`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/builts/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.built.BuiltResource.downloadExcel
     */
    downloadExcel$GET$api_builts_excel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; startDate?: Date; endDate?: Date; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/builts/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/builts/results/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.built.BuiltResource.downloadExcel
     */
    downloadExcel$GET$api_builts_results_excel(queryParams?: { direction?: Direction; organization?: string; road?: number; lanes?: number[]; headMilestone?: number; tailMilestone?: number; segmentLength?: number; startDate?: Date; endDate?: Date; metric?: Metrics; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/builts/results/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/builts/template
     * Java method: br.com.rrunner.pavrunner.domain.data.built.BuiltResource.downloadTemplate
     */
    downloadTemplate(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/builts/template`, options: options });
    }
}

export class OrganizationResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/organizations
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.create
     */
    create(detail: OrganizationDetailData, options?: O): RestResponse<OrganizationDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/organizations`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/organizations
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.query
     */
    query(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<OrganizationSummaryDTO>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/organizations`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/organizations/export/excel
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.downloadExcel
     */
    downloadExcel(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/organizations/export/excel`, options: options });
    }

    /**
     * HTTP POST /api/organizations/import/excel
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.uploadExcel
     */
    uploadExcel(options?: O): RestResponse<{ [index: string]: any }> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/organizations/import/excel`, options: options });
    }

    /**
     * HTTP GET /api/organizations/template/excel
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.downloadTemplate
     */
    downloadTemplate(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/organizations/template/excel`, options: options });
    }

    /**
     * HTTP DELETE /api/organizations/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/organizations/${id}`, options: options });
    }

    /**
     * HTTP GET /api/organizations/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.get
     */
    get(id: number, options?: O): RestResponse<OrganizationDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/organizations/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/organizations/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.organization.OrganizationResource.put
     */
    put(id: number, detail: OrganizationDetailData, options?: O): RestResponse<OrganizationDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/organizations/${id}`, data: detail, options: options });
    }
}

export class RoadResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/roads
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.create
     */
    create(detail: RoadDetailData, options?: O): RestResponse<RoadDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/roads`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/roads
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.query
     */
    query(queryParams?: { query?: string; organization?: number; empty?: boolean; roadtype?: RoadType; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<RoadResumeData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roads`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /api/roads/dependencies
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.getDependencies
     */
    getDependencies(ids: number[], options?: O): RestResponse<RoadDependenciesDTO> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/roads/dependencies`, data: ids, options: options });
    }

    /**
     * HTTP GET /api/roads/geometry/excel
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.downloadExcelRoadsGeometry
     */
    downloadExcelRoadsGeometry(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roads/geometry/excel`, options: options });
    }

    /**
     * HTTP POST /api/roads/import/excel
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.uploadExcel
     */
    uploadExcel(queryParams?: { organizations?: string; }, options?: O): RestResponse<{ [index: string]: any }> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/roads/import/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/roads/summary
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.getSummary
     */
    getSummary(queryParams: { organizationId: number; }, options?: O): RestResponse<RoadSummaryDTO[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roads/summary`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/roads/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/roads/${id}`, options: options });
    }

    /**
     * HTTP GET /api/roads/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.get
     */
    get(id: number, options?: O): RestResponse<RoadDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roads/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/roads/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.road.RoadResource.put
     */
    put(id: number, detail: RoadDetailData, options?: O): RestResponse<RoadDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/roads/${id}`, data: detail, options: options });
    }
}

export class ParametersVersionsResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/parameters-versions
     * Java method: br.com.rrunner.pavrunner.domain.data.systemparameters.ParametersVersionsResource.query
     */
    query(queryParams: { query: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ParametersVersionsData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/parameters-versions`, queryParams: queryParams, options: options });
    }
}

export class WeighingResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/weighings
     * Java method: br.com.rrunner.pavrunner.domain.data.weighing.WeighingResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/weighings`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/weighings
     * Java method: br.com.rrunner.pavrunner.domain.data.weighing.WeighingResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<WeighingData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/weighings`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/weighings/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.weighing.WeighingResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/weighings/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/weighings/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.weighing.WeighingResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/weighings/ranked`, queryParams: queryParams, options: options });
    }
}

export class SolutionHistoricSourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/solutionhistorics/{version}/{idplan}
     * Java method: br.com.rrunner.pavrunner.domain.data.solutions.SolutionHistoricSource.query
     */
    query(version: number, idplan: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<SolutionsHistoricData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/solutionhistorics/${version}/${idplan}`, queryParams: queryParams, options: options });
    }
}

export class AuditResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /management/audits
     * Java method: br.com.rrunner.pavrunner.domain.admin.audit.AuditResource.getAll
     */
    getAll(queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<AuditEvent>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`management/audits`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /management/audits
     * Java method: br.com.rrunner.pavrunner.domain.admin.audit.AuditResource.getByDates
     */
    getByDates(queryParams: { fromDate: Date; toDate: Date; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<AuditEvent>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`management/audits`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /management/audits/{id:.+}
     * Java method: br.com.rrunner.pavrunner.domain.admin.audit.AuditResource.get
     */
    get(id: number, options?: O): RestResponse<AuditEvent> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`management/audits/${id}`, options: options });
    }
}

export class ImportHistoryResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/import-history
     * Java method: br.com.rrunner.pavrunner.domain.data.importHistory.ImportHistoryResource.getUserHistory
     */
    getUserHistory(options?: O): RestResponse<ImportHistory[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/import-history`, options: options });
    }

    /**
     * HTTP GET /api/import-history/search
     * Java method: br.com.rrunner.pavrunner.domain.data.importHistory.ImportHistoryResource.searchHistory
     */
    searchHistory(queryParams?: { from?: Date; to?: Date; status?: ImportStatus; importType?: ImportType; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ImportHistory>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/import-history/search`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/import-history/{id}/errors
     * Java method: br.com.rrunner.pavrunner.domain.data.importHistory.ImportHistoryResource.getErrors
     */
    getErrors(id: number, options?: O): RestResponse<ImportErrorData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/import-history/${id}/errors`, options: options });
    }
}

export class IggResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/iggs
     * Java method: br.com.rrunner.pavrunner.domain.data.igg.IggResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/iggs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iggs
     * Java method: br.com.rrunner.pavrunner.domain.data.igg.IggResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<IggData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iggs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iggs/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.igg.IggResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iggs/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iggs/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.igg.IggResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iggs/ranked`, queryParams: queryParams, options: options });
    }
}

export class CostTableHistoricSourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/costtablehistorics/{version}/{idplan}
     * Java method: br.com.rrunner.pavrunner.domain.data.costtable.CostTableHistoricSource.query
     */
    query(version: number, idplan: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<CostTableHistoricData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/costtablehistorics/${version}/${idplan}`, queryParams: queryParams, options: options });
    }
}

export class PlanOverviewResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/plans-overviews
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.overview.PlanOverviewResource.create
     */
    create(detail: PlanOverviewData, options?: O): RestResponse<PlanOverviewData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/plans-overviews`, data: detail, options: options });
    }

    /**
     * HTTP DELETE /api/plans-overviews/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.overview.PlanOverviewResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/plans-overviews/${id}`, options: options });
    }

    /**
     * HTTP GET /api/plans-overviews/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.overview.PlanOverviewResource.get
     */
    get(id: number, options?: O): RestResponse<PlanOverviewData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/plans-overviews/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/plans-overviews/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.plan.overview.PlanOverviewResource.put
     */
    put(id: number, detail: PlanOverviewData, options?: O): RestResponse<PlanOverviewData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/plans-overviews/${id}`, data: detail, options: options });
    }
}

export class GrowthRateResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/growth-rates
     * Java method: br.com.rrunner.pavrunner.domain.entities.growthrate.GrowthRateResource.create
     */
    create(detail: GrowthRateData, options?: O): RestResponse<GrowthRateData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/growth-rates`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/growth-rates
     * Java method: br.com.rrunner.pavrunner.domain.entities.growthrate.GrowthRateResource.query
     */
    query(queryParams: { query: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<GrowthRateData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/growth-rates`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/growth-rates/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.growthrate.GrowthRateResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/growth-rates/${id}`, options: options });
    }

    /**
     * HTTP GET /api/growth-rates/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.growthrate.GrowthRateResource.ObjectId
     */
    ObjectId(id: number, options?: O): RestResponse<GrowthRateData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/growth-rates/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/growth-rates/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.growthrate.GrowthRateResource.update
     */
    update(id: number, detail: GrowthRateData, options?: O): RestResponse<GrowthRateData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/growth-rates/${id}`, data: detail, options: options });
    }
}

export class IfiResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/ifis
     * Java method: br.com.rrunner.pavrunner.domain.data.ifi.IfiResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/ifis`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/ifis
     * Java method: br.com.rrunner.pavrunner.domain.data.ifi.IfiResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<IfiData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/ifis`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/ifis/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.ifi.IfiResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/ifis/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/ifis/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.ifi.IfiResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/ifis/ranked`, queryParams: queryParams, options: options });
    }
}

export class IriResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/iris
     * Java method: br.com.rrunner.pavrunner.domain.data.iri.IriResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/iris`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iris
     * Java method: br.com.rrunner.pavrunner.domain.data.iri.IriResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<IriData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iris`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iris/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.iri.IriResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iris/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/iris/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.iri.IriResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/iris/ranked`, queryParams: queryParams, options: options });
    }
}

export class WorksResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/workss
     * Java method: br.com.rrunner.pavrunner.domain.data.works.WorksResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/workss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/workss
     * Java method: br.com.rrunner.pavrunner.domain.data.works.WorksResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<WorksData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/workss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/workss/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.works.WorksResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/workss/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/workss/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.works.WorksResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/workss/ranked`, queryParams: queryParams, options: options });
    }
}

export class ProbingResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/probings
     * Java method: br.com.rrunner.pavrunner.domain.data.probing.ProbingResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/probings`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/probings
     * Java method: br.com.rrunner.pavrunner.domain.data.probing.ProbingResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ProbingData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/probings`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/probings/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.probing.ProbingResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/probings/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/probings/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.probing.ProbingResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/probings/ranked`, queryParams: queryParams, options: options });
    }
}

export class DataResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/import/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.DataResource.uploadExcel
     */
    uploadExcel$POST$api_import_excel(options?: O): RestResponse<{ [index: string]: any }> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/import/excel`, options: options });
    }

    /**
     * HTTP POST /api/import/excel/{planId}
     * Java method: br.com.rrunner.pavrunner.domain.data.DataResource.uploadExcel
     */
    uploadExcel$POST$api_import_excel_planId(planId: number, options?: O): RestResponse<{ [index: string]: any }> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/import/excel/${planId}`, options: options });
    }
}

export class CostTableResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/cost-tables
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.CostTableResource.create
     */
    create(detail: CostTableDetailData, options?: O): RestResponse<CostTableDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/cost-tables`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/cost-tables
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.CostTableResource.get
     */
    get$GET$api_costtables(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<Link<CostTable>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/cost-tables`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/cost-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.CostTableResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/cost-tables/${id}`, options: options });
    }

    /**
     * HTTP GET /api/cost-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.CostTableResource.get
     */
    get$GET$api_costtables_id(id: number, options?: O): RestResponse<CostTableDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/cost-tables/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/cost-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.CostTableResource.put
     */
    put(id: number, detail: CostTableDetailData, options?: O): RestResponse<CostTableDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/cost-tables/${id}`, data: detail, options: options });
    }
}

export class ConstantSetResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/constant-sets
     * Java method: br.com.rrunner.pavrunner.domain.entities.constantset.ConstantSetResource.create
     */
    create(detail: ConstantSetData, options?: O): RestResponse<ConstantSetData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/constant-sets`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/constant-sets
     * Java method: br.com.rrunner.pavrunner.domain.entities.constantset.ConstantSetResource.select
     */
    select(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ConstantSetData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/constant-sets`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/constant-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.constantset.ConstantSetResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/constant-sets/${id}`, options: options });
    }

    /**
     * HTTP GET /api/constant-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.constantset.ConstantSetResource.get
     */
    get(id: number, options?: O): RestResponse<ConstantSetData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/constant-sets/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/constant-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.constantset.ConstantSetResource.put
     */
    put(id: number, detail: ConstantSetData, options?: O): RestResponse<ConstantSetData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/constant-sets/${id}`, data: detail, options: options });
    }
}

export class AllPlansByProjectResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/allPlansByProject
     * Java method: br.com.rrunner.pavrunner.domain.data.allPlansByProject.AllPlansByProjectResource.create
     */
    create(vm: AllPlansByProjectData, options?: O): RestResponse<AllPlansByProjectData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/allPlansByProject`, data: vm, options: options });
    }

    /**
     * HTTP GET /api/allPlansByProject
     * Java method: br.com.rrunner.pavrunner.domain.data.allPlansByProject.AllPlansByProjectResource.select
     */
    select(queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<AllPlansByProjectData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/allPlansByProject`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/allPlansByProject/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.allPlansByProject.AllPlansByProjectResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/allPlansByProject/${id}`, options: options });
    }

    /**
     * HTTP GET /api/allPlansByProject/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.allPlansByProject.AllPlansByProjectResource.get
     */
    get(id: number, options?: O): RestResponse<AllPlansByProjectData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/allPlansByProject/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/allPlansByProject/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.allPlansByProject.AllPlansByProjectResource.update
     */
    update(id: number, detail: AllPlansByProjectData, options?: O): RestResponse<AllPlansByProjectData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/allPlansByProject/${id}`, data: detail, options: options });
    }
}

export class ConstantHistoricSourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/constanthistorics/{version}/{idplan}
     * Java method: br.com.rrunner.pavrunner.domain.data.constanthistoric.ConstantHistoricSource.query
     */
    query(version: number, idplan: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ConstantHistoricData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/constanthistorics/${version}/${idplan}`, queryParams: queryParams, options: options });
    }
}

export class BudgetLimitResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/budgetlimits
     * Java method: br.com.rrunner.pavrunner.domain.entities.budgetlimit.BudgetLimitResource.create
     */
    create(detail: BudgetLimitData, options?: O): RestResponse<BudgetLimitData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/budgetlimits`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/budgetlimits
     * Java method: br.com.rrunner.pavrunner.domain.entities.budgetlimit.BudgetLimitResource.query
     */
    query(queryParams: { query: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<BudgetLimitData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/budgetlimits`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/budgetlimits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.budgetlimit.BudgetLimitResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/budgetlimits/${id}`, options: options });
    }

    /**
     * HTTP GET /api/budgetlimits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.budgetlimit.BudgetLimitResource.get
     */
    get(id: number, options?: O): RestResponse<BudgetLimitData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/budgetlimits/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/budgetlimits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.budgetlimit.BudgetLimitResource.update
     */
    update(id: number, detail: BudgetLimitData, options?: O): RestResponse<BudgetLimitData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/budgetlimits/${id}`, data: detail, options: options });
    }
}

export class SegmentsResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/segmentss
     * Java method: br.com.rrunner.pavrunner.domain.data.segments.SegmentsResource.create
     */
    create(detail: SegmentsData, options?: O): RestResponse<SegmentsData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/segmentss`, data: detail, options: options });
    }

    /**
     * HTTP DELETE /api/segmentss/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.segments.SegmentsResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/segmentss/${id}`, options: options });
    }

    /**
     * HTTP GET /api/segmentss/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.segments.SegmentsResource.get
     */
    get(id: number, options?: O): RestResponse<SegmentsData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/segmentss/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/segmentss/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.segments.SegmentsResource.put
     */
    put(id: number, detail: SegmentsData, options?: O): RestResponse<SegmentsData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/segmentss/${id}`, data: detail, options: options });
    }
}

export class CriteriaSetResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/criteria-sets
     * Java method: br.com.rrunner.pavrunner.domain.entities.criteriaset.CriteriaSetResource.create
     */
    create(detail: CriteriaSetData, options?: O): RestResponse<CriteriaSetData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/criteria-sets`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/criteria-sets
     * Java method: br.com.rrunner.pavrunner.domain.entities.criteriaset.CriteriaSetResource.select
     */
    select(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<CriteriaSetData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/criteria-sets`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/criteria-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.criteriaset.CriteriaSetResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/criteria-sets/${id}`, options: options });
    }

    /**
     * HTTP GET /api/criteria-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.criteriaset.CriteriaSetResource.get
     */
    get(id: number, options?: O): RestResponse<CriteriaSetData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/criteria-sets/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/criteria-sets/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.criteriaset.CriteriaSetResource.put
     */
    put(id: number, detail: CriteriaSetData, options?: O): RestResponse<CriteriaSetData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/criteria-sets/${id}`, data: detail, options: options });
    }
}

export class UnitPriceTablesResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/unit-price-tables
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.create
     */
    create(detail: UnitPriceTablesData, options?: O): RestResponse<UnitPriceTablesData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/unit-price-tables`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/unit-price-tables
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.get
     */
    get$GET$api_unitpricetables(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<UnitPriceTablesData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unit-price-tables`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/unit-price-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/unit-price-tables/${id}`, options: options });
    }

    /**
     * HTTP GET /api/unit-price-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.get
     */
    get$GET$api_unitpricetables_id(id: number, options?: O): RestResponse<UnitPriceTablesData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unit-price-tables/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/unit-price-tables/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.put
     */
    put(id: number, detail: UnitPriceTablesData, options?: O): RestResponse<UnitPriceTablesData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/unit-price-tables/${id}`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/unit-price-tables/{id}/linked-cost-tables
     * Java method: br.com.rrunner.pavrunner.domain.entities.costtable.UnitPriceTablesResource.getLinkedCostTables
     */
    getLinkedCostTables(id: number, options?: O): RestResponse<IdNameDto[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/unit-price-tables/${id}/linked-cost-tables`, options: options });
    }
}

export class DecisionTreeHistoricSourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/decisiontreehistorics/{version}/{idplan}
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontreehistoric.DecisionTreeHistoricSource.query
     */
    query(version: number, idplan: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<DecisionTreeHistoricData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/decisiontreehistorics/${version}/${idplan}`, queryParams: queryParams, options: options });
    }
}

export class RoleResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/roles
     * Java method: br.com.rrunner.pavrunner.domain.admin.role.RoleResource.create
     */
    create(detail: RoleDetailData, options?: O): RestResponse<RoleDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/roles`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/roles
     * Java method: br.com.rrunner.pavrunner.domain.admin.role.RoleResource.query
     */
    query(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<Link<Role>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roles`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/roles/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.role.RoleResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/roles/${id}`, options: options });
    }

    /**
     * HTTP GET /api/roles/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.role.RoleResource.get
     */
    get(id: number, options?: O): RestResponse<RoleDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/roles/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/roles/{id}
     * Java method: br.com.rrunner.pavrunner.domain.admin.role.RoleResource.put
     */
    put(id: number, detail: RoleDetailData, options?: O): RestResponse<RoleDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/roles/${id}`, data: detail, options: options });
    }
}

export class GripResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/grips
     * Java method: br.com.rrunner.pavrunner.domain.data.grip.GripResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/grips`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/grips
     * Java method: br.com.rrunner.pavrunner.domain.data.grip.GripResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<GripData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/grips`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/grips/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.grip.GripResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/grips/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/grips/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.grip.GripResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/grips/ranked`, queryParams: queryParams, options: options });
    }
}

export class StructureResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/structures
     * Java method: br.com.rrunner.pavrunner.domain.data.structure.StructureResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/structures`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/structures
     * Java method: br.com.rrunner.pavrunner.domain.data.structure.StructureResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<StructureData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/structures`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/structures/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.structure.StructureResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/structures/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/structures/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.structure.StructureResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/structures/ranked`, queryParams: queryParams, options: options });
    }
}

export class SeedDataResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/management/seeds
     * Java method: br.com.rrunner.pavrunner.domain.system.SeedDataResource.post
     */
    post(queryParams: { code: string; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/management/seeds`, queryParams: queryParams, options: options });
    }
}

export class ProjectResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/projects
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.create
     */
    create(detail: ProjectData, options?: O): RestResponse<ProjectData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/projects`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/projects
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.get
     */
    get(queryParams?: { name?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<ProjectData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/projects`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/projects/group
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.query
     */
    query(queryParams: { onlyUsed: boolean; }, options?: O): RestResponse<ProjectData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/projects/group`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/projects/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/projects/${id}`, options: options });
    }

    /**
     * HTTP GET /api/projects/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.getById
     */
    getById(id: number, options?: O): RestResponse<ProjectData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/projects/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/projects/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.update
     */
    update(id: number, detail: ProjectData, options?: O): RestResponse<ProjectData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/projects/${id}`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/projects/{id}/dependencies
     * Java method: br.com.rrunner.pavrunner.domain.data.project.ProjectResource.getDependencies
     */
    getDependencies(id: number, options?: O): RestResponse<ProjectDependenciesDTO> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/projects/${id}/dependencies`, options: options });
    }
}

export class VrdResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/vrds
     * Java method: br.com.rrunner.pavrunner.domain.data.vrd.VrdResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/vrds`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/vrds
     * Java method: br.com.rrunner.pavrunner.domain.data.vrd.VrdResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<VrdData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/vrds`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/vrds/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.vrd.VrdResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/vrds/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/vrds/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.vrd.VrdResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/vrds/ranked`, queryParams: queryParams, options: options });
    }
}

export class SatResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/sats
     * Java method: br.com.rrunner.pavrunner.domain.data.sat.SatResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/sats`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/sats
     * Java method: br.com.rrunner.pavrunner.domain.data.sat.SatResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<SatData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/sats`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/sats/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.sat.SatResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/sats/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/sats/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.sat.SatResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/sats/ranked`, queryParams: queryParams, options: options });
    }
}

export class MetricLimitResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/metrics/limits
     * Java method: br.com.rrunner.pavrunner.domain.data.metric.limit.MetricLimitResource.create
     */
    create(detail: MetricLimitData, options?: O): RestResponse<MetricLimitData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/metrics/limits`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/metrics/limits
     * Java method: br.com.rrunner.pavrunner.domain.data.metric.limit.MetricLimitResource.search
     */
    search(queryParams?: { organization?: number; measurement?: Measurements; metric?: Metrics; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<MetricLimitData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metrics/limits`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/metrics/limits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.metric.limit.MetricLimitResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/metrics/limits/${id}`, options: options });
    }

    /**
     * HTTP GET /api/metrics/limits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.metric.limit.MetricLimitResource.get
     */
    get(id: number, options?: O): RestResponse<MetricLimitData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metrics/limits/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/metrics/limits/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.metric.limit.MetricLimitResource.put
     */
    put(id: number, detail: MetricLimitData, options?: O): RestResponse<MetricLimitData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/metrics/limits/${id}`, data: detail, options: options });
    }
}

export class DecisionTreeResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/decision-trees
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.create
     */
    create(detail: DecisionTreeDetailData, options?: O): RestResponse<DecisionTreeDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/decision-trees`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/decision-trees
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.get
     */
    get$GET$api_decisiontrees(queryParams?: { query?: string; page?: number; size?: number; sort?: string; decisionTreeProject?: number; situation?: DecisionTreeSituation; }, options?: O): RestResponse<Page<DecisionTreeSearchData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/decision-trees`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/decision-trees/all
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.queryAll
     */
    queryAll(queryParams?: { query?: string; }, options?: O): RestResponse<DecisionTreeData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/decision-trees/all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /api/decision-trees/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/decision-trees/${id}`, options: options });
    }

    /**
     * HTTP GET /api/decision-trees/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.get
     */
    get$GET$api_decisiontrees_id(id: number, options?: O): RestResponse<DecisionTreeDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/decision-trees/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/decision-trees/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.decisiontree.DecisionTreeResource.put
     */
    put(id: number, detail: DecisionTreeDetailData, options?: O): RestResponse<DecisionTreeDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/decision-trees/${id}`, data: detail, options: options });
    }
}

export class SolutionResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /api/solutions
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.create
     */
    create(detail: SolutionDetailData, options?: O): RestResponse<SolutionDetailData> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/solutions`, data: detail, options: options });
    }

    /**
     * HTTP GET /api/solutions
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.query
     */
    query(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<Link<Solution>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/solutions`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/solutions/all
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.queryAll
     */
    queryAll(queryParams?: { query?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Link<Solution>[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/solutions/all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/solutions/solutionsList
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.querySolutionsList
     */
    querySolutionsList(options?: O): RestResponse<SolutionDetailData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/solutions/solutionsList`, options: options });
    }

    /**
     * HTTP DELETE /api/solutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.delete
     */
    delete(id: number, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/solutions/${id}`, options: options });
    }

    /**
     * HTTP GET /api/solutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.get
     */
    get(id: number, options?: O): RestResponse<SolutionDetailData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/solutions/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/solutions/{id}
     * Java method: br.com.rrunner.pavrunner.domain.entities.solution.SolutionResource.put
     */
    put(id: number, detail: SolutionDetailData, options?: O): RestResponse<SolutionDetailData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/solutions/${id}`, data: detail, options: options });
    }
}

export class SystemResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/timezones
     * Java method: br.com.rrunner.pavrunner.domain.system.SystemResource.getTimezones
     */
    getTimezones(options?: O): RestResponse<string[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/timezones`, options: options });
    }
}

export class HsResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/hss
     * Java method: br.com.rrunner.pavrunner.domain.data.hs.HsResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/hss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/hss
     * Java method: br.com.rrunner.pavrunner.domain.data.hs.HsResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<HsData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/hss`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/hss/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.hs.HsResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/hss/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/hss/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.hs.HsResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/hss/ranked`, queryParams: queryParams, options: options });
    }
}

export class FwdResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/fwds
     * Java method: br.com.rrunner.pavrunner.domain.data.fwd.FwdResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/fwds`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/fwds
     * Java method: br.com.rrunner.pavrunner.domain.data.fwd.FwdResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<FwdData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/fwds`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/fwds/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.fwd.FwdResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/fwds/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/fwds/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.fwd.FwdResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/fwds/ranked`, queryParams: queryParams, options: options });
    }
}

export class AuditLogResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/auditLogs
     * Java method: br.com.rrunner.pavrunner.domain.data.auditLog.AuditLogResource.query
     */
    query(queryParams?: { userName?: string; module?: string; operation?: OperationTypeEnum; startDate?: Date; endDate?: Date; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<AuditLogData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/auditLogs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/auditLogs/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.auditLog.AuditLogResource.downloadExcelAuditLog
     */
    downloadExcelAuditLog(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/auditLogs/excel`, options: options });
    }
}

export class SystemParametersResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/systemparameters
     * Java method: br.com.rrunner.pavrunner.domain.data.systemparameters.SystemParametersResource.query
     */
    query(queryParams: { query: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<SystemParametersData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/systemparameters`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/systemparameters/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.systemparameters.SystemParametersResource.get
     */
    get(id: number, options?: O): RestResponse<SystemParametersData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/systemparameters/${id}`, options: options });
    }

    /**
     * HTTP PUT /api/systemparameters/{id}
     * Java method: br.com.rrunner.pavrunner.domain.data.systemparameters.SystemParametersResource.update
     */
    update(id: number, detail: SystemParametersData, options?: O): RestResponse<SystemParametersData> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/systemparameters/${id}`, data: detail, options: options });
    }
}

export class PlanHistoricSourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/planhistoric/{idplan}
     * Java method: br.com.rrunner.pavrunner.domain.data.planhistoric.PlanHistoricSource.query
     */
    query(idplan: number, queryParams?: { page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<PlanHistoricData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/planhistoric/${idplan}`, queryParams: queryParams, options: options });
    }
}

export class MetadataResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /api/metadata/geodata
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; measurement: Measurements; metric?: string; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/geodata`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/metadata/kartado/sync
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.syncDataKartado
     */
    syncDataKartado(options?: O): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/kartado/sync`, options: options });
    }

    /**
     * HTTP GET /api/metadata/measurements
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.getMeasurements
     */
    getMeasurements(queryParams?: { calculated?: boolean; }, options?: O): RestResponse<Iterable<MeasurementsData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/measurements`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/metadata/measurements/{code}
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.getMeasurement
     */
    getMeasurement(code: string, options?: O): RestResponse<MeasurementsData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/measurements/${code}`, options: options });
    }

    /**
     * HTTP GET /api/metadata/metrics
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.getMetrics
     */
    getMetrics(queryParams?: { measurement?: Measurements; view?: MetricViews; }, options?: O): RestResponse<Iterable<MetricsData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/metrics`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/metadata/metrics/{code}
     * Java method: br.com.rrunner.pavrunner.domain.data.metadata.MetadataResource.getMetric
     */
    getMetric(code: string, options?: O): RestResponse<MetricsData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/metadata/metrics/${code}`, options: options });
    }
}

export class LogsResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP PUT /management/logs
     * Java method: br.com.rrunner.pavrunner.domain.system.LogsResource.changeLevel
     */
    changeLevel(jsonLogger: LoggerVM, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`management/logs`, data: jsonLogger, options: options });
    }

    /**
     * HTTP GET /management/logs
     * Java method: br.com.rrunner.pavrunner.domain.system.LogsResource.getList
     */
    getList(options?: O): RestResponse<LoggerVM[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`management/logs`, options: options });
    }
}

export class NoiseResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/noises
     * Java method: br.com.rrunner.pavrunner.domain.data.noise.NoiseResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/noises`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/noises
     * Java method: br.com.rrunner.pavrunner.domain.data.noise.NoiseResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<NoiseData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/noises`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/noises/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.noise.NoiseResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/noises/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/noises/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.noise.NoiseResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/noises/ranked`, queryParams: queryParams, options: options });
    }
}

export class TrResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/trs
     * Java method: br.com.rrunner.pavrunner.domain.data.tr.TrResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/trs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/trs
     * Java method: br.com.rrunner.pavrunner.domain.data.tr.TrResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<TrData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/trs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/trs/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.tr.TrResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/trs/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/trs/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.tr.TrResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/trs/ranked`, queryParams: queryParams, options: options });
    }
}

export class TestResourceClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP DELETE /api/tests
     * Java method: br.com.rrunner.pavrunner.domain.data.test.TestResource.delete
     */
    delete(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/tests`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/tests
     * Java method: br.com.rrunner.pavrunner.domain.data.test.TestResource.query
     */
    query(queryParams: { road: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<Page<TestData>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/tests`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/tests/excel
     * Java method: br.com.rrunner.pavrunner.domain.data.test.TestResource.downloadExcel
     */
    downloadExcel(queryParams?: { road?: number; campaigns?: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; page?: number; size?: number; sort?: string; }, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/tests/excel`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/tests/ranked
     * Java method: br.com.rrunner.pavrunner.domain.data.test.TestResource.queryRanked
     */
    queryRanked(queryParams: { road: number; campaigns: number[]; headMilestone?: number; tailMilestone?: number; direction?: Direction; lanes?: number[]; }, options?: O): RestResponse<MetricRankedData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/tests/ranked`, queryParams: queryParams, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type Authority = "ANONYMOUS" | "SYSTEM" | "ENTITIES_READ" | "ENTITIES_WRITE" | "MEASUREMENTS_READ" | "MEASUREMENTS_WRITE" | "ANALYSIS_READ" | "ANALYSIS_WRITE" | "USERS_READ" | "USERS_WRITE" | "ORGANIZATIONS_READ" | "ORGANIZATIONS_WRITE" | "ENTITIES_PARTIAL_READ" | "MEASUREMENTS_PARTIAL_READ" | "MEASUREMENTS_PARTIAL_WRITE" | "ANALYSIS_PARTIAL_READ" | "ANALYSIS_PARTIAL_WRITE" | "PROFILE_QUERY_DATA" | "ROAD_READ" | "ROAD_WRITE" | "SOLUTIONS_READ" | "SOLUTIONS_WRITE" | "CAMPAIGN_READ" | "CAMPAIGN_WRITE" | "CONSTANTSET_READ" | "CONSTANTSET_WRITE" | "METRICLIMIT_READ" | "METRICLIMIT_WRITE" | "COSTTABLE_READ" | "COSTTABLE_WRITE" | "CRITERIASET_READ" | "CRITERIASET_WRITE" | "MEASUREMENT_READ" | "MEASUREMENT_WRITE" | "UNIFILARPARAMETERS_READ" | "UNIFILARPARAMETERS_WRITE" | "GAPIDENTIFICATION_READ" | "GAPIDENTIFICATION_WRITE" | "ASBUILT_READ" | "ASBUILT_WRITE" | "DECISIONTREE_READ" | "DECISIONTREE_WRITE" | "PLANS_READ" | "PLANS_WRITE" | "MECHANICAL_READ" | "MECHANICAL_WRITE" | "PAVEMENTPERFORMANCE_READ" | "PAVEMENTPERFORMANCE_WRITE" | "REINFORCEMENTCALCULATION_READ" | "REINFORCEMENTCALCULATION_WRITE" | "IQDTEST_READ" | "IQDTEST_WRITE" | "IQDCALCULATION_READ" | "IQDCALCULATION_WRITE" | "EXTERNALSYSTEMS_READ" | "EXTERNALSYSTEMS_WRITE" | "MEASUREMENT_IMPORT" | "UNIFILARPARAMETERS_IMPORT" | "GAPIDENTIFICATION_IMPORT" | "ASBUILT_IMPORT" | "MECHANISTICANALYSISDATAS_IMPORTAR" | "GROWTHRATE_WRITE" | "GROWTHRATE_READ" | "BUDGET_LIMIT_WRITE" | "BUDGET_LIMIT_READ" | "INDEX_CROSSING_READ" | "INDEX_CROSSING_WRITE" | "PLANS_BY_PROJECT_READ" | "PLANS_BY_PROJECT_WRITE" | "REMOVE_DUPLICATED_MEASUREMENTS" | "PARAMETEREVOLUTION_READ" | "PARAMETEREVOLUTION_WRITE" | "IMPORT_HISTORY_READ" | "PROJECT_READ" | "PROJECT_WRITE" | "ORGANIZATIONS_IMPORT";

export type Direction = "DEC" | "INC" | "BOTH";

export type DataSourceEnum = "INTERNAL" | "KARTADO";

export type DecisionTreeNodeItemType = "SINGLE" | "GROUP";

export type BooleanOperators = "AND" | "OR";

export type LogicalOperators = "EQ" | "LT" | "GT" | "NE" | "LE" | "GE";

export type Metrics = "FWD_FORCE" | "FWD_D0" | "FWD_D20" | "FWD_D30" | "FWD_D45" | "FWD_D60" | "FWD_D90" | "FWD_D120" | "FWD_AIR_TEMPERATURE" | "FWD_PAVEMENT_TEMPERATURE" | "FWD_NORMALIZED_D0" | "FWD_NORMALIZED_D20" | "FWD_NORMALIZED_D30" | "FWD_NORMALIZED_D45" | "FWD_NORMALIZED_D60" | "FWD_NORMALIZED_D90" | "FWD_NORMALIZED_D120" | "FWD_RADIUS" | "FWD_DELTA_D0_D45" | "HS_HS" | "VRD_VRD" | "IFI_MACROTEXTURE_MEASURE" | "IFI_MiCROTEXTURE_MEASURE" | "IFI_FR60" | "IFI_IFI_SP" | "IFI_IFI_F60" | "URCI_URCI" | "NOISE_SPEED" | "NOISE_NOISE" | "PROBING_LAYER1THICKNESS" | "PROBING_LAYER1MATERIAL" | "PROBING_LAYER2THICKNESS" | "PROBING_LAYER2MATERIAL" | "PROBING_LAYER3THICKNESS" | "PROBING_LAYER3MATERIAL" | "PROBING_LAYER4THICKNESS" | "PROBING_LAYER4MATERIAL" | "STRUCTURE_LAYER1THICKNESS" | "STRUCTURE_LAYER1MATERIAL" | "STRUCTURE_LAYER2THICKNESS" | "STRUCTURE_LAYER2MATERIAL" | "STRUCTURE_LAYER3THICKNESS" | "STRUCTURE_LAYER3MATERIAL" | "STRUCTURE_LAYER4THICKNESS" | "STRUCTURE_LAYER4MATERIAL" | "GRIP_SPEED" | "GRIP_GN" | "WEIGHING_PBT" | "WEIGHING_AXLEGROUP1" | "WEIGHING_AXLEGROUP2" | "WEIGHING_AXLEGROUP3" | "WEIGHING_AXLEGROUP4" | "WEIGHING_AXLEGROUP5" | "WEIGHING_AXLEGROUP6" | "IGG_OUTER_FL" | "IGG_INNER_FL" | "IGG_FC2" | "IGG_FC3" | "IGG_PA" | "IGG_AT_ON" | "IGG_IGI" | "IGG_ATR_AVERAGE" | "IGG_ATR_VARIANCE" | "IGG_IGG" | "TEST_DENSITY" | "TEST_MOISTURE" | "TEST_LL" | "TEST_LP" | "TEST_IP" | "TEST_GRANULOMETRYN4" | "TEST_GRANULOMETRYN10" | "TEST_GRANULOMETRYN40" | "TEST_GRANULOMETRYN200" | "TEST_HRB" | "TEST_MCT" | "TEST_MAX" | "TEST_HOT" | "TEST_EXP" | "TEST_CBR" | "UNIFILARWORKS_EXTENSION" | "UNIFILARWORKS_EXECUTIONDATE" | "UNIFILARWORKS_BATCH" | "UNIFILARWORKS_COUNTY" | "UNIFILARWORKS_SERVICE" | "UNIFILARWORKS_SUBITEM" | "UNIFILARWORKS_NAMETPU" | "UNIFILARWORKS_LENGTHWORK" | "UNIFILARWORKS_WIDTH" | "UNIFILARWORKS_THICKNESS" | "UNIFILARWORKS_DENSITY" | "UNIFILARWORKS_LAYERAMOUNT" | "UNIFILARWORKS_LOCATION" | "UNIFILARWORKS_FREQUENCY" | "UNIFILARWORKS_UNIT" | "UNIFILARWORKS_AREA" | "UNIFILARWORKS_VOLUME" | "UNIFILARWORKS_TON" | "ICP_EXTENSION" | "ICP_APA" | "ICP_BOA" | "ICP_DEA" | "ICP_DJA" | "ICP_DPAA" | "ICP_DSJA" | "ICP_EJA" | "ICP_FCA" | "ICP_FLA" | "ICP_FRA" | "ICP_GRA" | "ICP_PBA" | "ICP_PDA" | "ICP_PNA" | "ICP_PRA" | "ICP_QCA" | "ICP_QLA" | "ICP_REA" | "ICP_APM" | "ICP_BOM" | "ICP_DEM" | "ICP_DJM" | "ICP_DPAM" | "ICP_DSJM" | "ICP_EJM" | "ICP_FCM" | "ICP_FLM" | "ICP_FRM" | "ICP_GRM" | "ICP_PBM" | "ICP_PDM" | "ICP_PNM" | "ICP_PRM" | "ICP_QCM" | "ICP_QLM" | "ICP_REM" | "ICP_APB" | "ICP_BOB" | "ICP_DEB" | "ICP_DJB" | "ICP_DPAB" | "ICP_DSJB" | "ICP_EJB" | "ICP_FCB" | "ICP_FLB" | "ICP_FRB" | "ICP_GRB" | "ICP_PBB" | "ICP_PDB" | "ICP_PNB" | "ICP_PRB" | "ICP_QCB" | "ICP_QLB" | "ICP_REB" | "ICP_ICP" | "WORKS_EXTENSION" | "WORKS_SOLUTION" | "WORKS_EXECUTIONDATE" | "WORKS_COMMENTS" | "BUILT_EXTENSION" | "BUILT_SOLUTION" | "BUILT_SOLUTIONTYPE" | "IRI_SPEED" | "IRI_INNER_IRI" | "IRI_OUTER_IRI" | "IRI_IRI_AVERAGE" | "IRI_INNER_QI" | "IRI_OUTER_QI" | "IRI_QI_AVERAGE" | "SAT_LIGHT_VEHICLE_DAILY_AVERAGE" | "SAT_HEAVY_VEHICLE_DAILY_AVERAGE" | "SAT_USACE_VEHICLE_FACTOR" | "SAT_AASHTO_VEHICLE_FACTOR" | "TR_FC1" | "TR_FC2" | "TR_FC3" | "TR_POTHOLE" | "TR_SINKING" | "TR_OTHERS" | "KPI_HR_PRO_269" | "KPI_URCI" | "KPI_FC3" | "KPI_FC2" | "KPI_NOISE" | "KPI_IFI" | "KPI_LIFESPAN" | "KPI_VRD" | "KPI_GN" | "KPI_HS" | "KPI_HEAD_MILESTONE" | "KPI_P21_PAVED" | "KPI_P21_NOT_PAVED" | "KPI_DADM" | "KPI_D0" | "KPI_TAIL_MILESTONE" | "KPI_AGE" | "KPI_YEAR" | "KPI_INTERVENTION_AGE" | "KPI_INTERVENTION_YEAR" | "KPI_COST" | "KPI_AREA" | "KPI_SNC" | "KPI_DC" | "KPI_D120" | "KPI_TR" | "KPI_TR_AGE" | "KPI_RADIUS" | "KPI_QI" | "KPI_IRI" | "KPI_IGG" | "KPI_ARROW" | "KPI_HEAVY_VEHICLE_DAILY_AVERAGE" | "KPI_USACE_VEHICLE_FACTOR" | "KPI_USACE_NUMBER" | "KPI_AASHTO_VEHICLE_FACTOR" | "KPI_AASHTO_NUMBER" | "KPI_HR_PRO_011" | "KPI_HR_PRO_159" | "KPI_INTERVENTION_AREA" | "KPI_ICP" | "KPI_ATR" | "PAVING_TYPE" | "KPI_ROAD" | "KPI_DIRECTION" | "KPI_LANE" | "BEFORE_KPI_HR_PRO_269" | "BEFORE_KPI_NOISE" | "BEFORE_KPI_IFI" | "BEFORE_KPI_VRD" | "BEFORE_KPI_GN" | "BEFORE_KPI_HS" | "BEFORE_KPI_COST" | "BEFORE_KPI_AREA" | "BEFORE_KPI_SNC" | "BEFORE_KPI_DC" | "BEFORE_KPI_D120" | "BEFORE_KPI_TR" | "BEFORE_KPI_RADIUS" | "BEFORE_KPI_IRI" | "BEFORE_KPI_IGG" | "BEFORE_KPI_ARROW" | "BEFORE_KPI_HEAVY_VEHICLE_DAILY_AVERAGE" | "BEFORE_KPI_USACE_VEHICLE_FACTOR" | "BEFORE_KPI_USACE_NUMBER" | "BEFORE_KPI_AASHTO_VEHICLE_FACTOR" | "BEFORE_KPI_HR_PRO_011" | "BEFORE_KPI_HR_PRO_159" | "BEFORE_KPI_ICP" | "BEFORE_KPI_ATR" | "BEFORE_KPI_INTERVENTION_AREA";

export type DecisionTreeItemType = "NODE" | "LEAF";

export type DecisionTreeSituation = "ACTIVE" | "INACTIVE";

export type IqdType = "DEFAULT" | "IQDTEST";

export type Measurements = "FWD" | "IRI" | "IGG" | "TEST" | "TR" | "SAT" | "HS" | "VRD" | "IFI" | "URCI" | "NOISE" | "KPI" | "PROBING" | "STRUCTURE" | "GRIP" | "WEIGHING" | "UNIFILARWORKS" | "BUILT" | "WORKS" | "ICP";

export type Units = "NONE" | "KGF" | "C" | "KM_H" | "M_KM" | "COUNT_KM" | "PERCENT" | "MM_CENT" | "MM" | "CM" | "KM" | "M2" | "MONEY" | "YEAR" | "KG" | "STRING" | "PT" | "M3" | "M" | "UN";

export type StatusProcessEntityType = "PROCESSING" | "DONE" | "ERROR" | "INITIAL";

export type RateType = "FIXED" | "VARIABLE";

export type RoadType = "ROAD" | "STRETCH" | "RIVER";

export type PlanStatus = "CREATED" | "RUNNING" | "SUCCESS" | "FAILURE";

export type PlanType = "DEFAULT" | "P21" | "PAVEMENTPERFORMANCE" | "REINFORCEMENT" | "GAPS" | "INDEX_CROSSING" | "NONE";

export type ProjectStatus = "NEW" | "OLD" | "SELECT";

export type RoadSegmentType = "SINGLE" | "DOUBLE";

export type SolutionType = "ABOVE" | "BELOW" | "UNIQUE";

export type OperationTypeEnum = "INSERT" | "UPDATE" | "SELECT" | "DELETE" | "IMPORT";

export type ImportStatus = "IN_PROGRESS" | "COMPLETED" | "INCOMPLETED" | "FAILED";

export type ImportType = "EXCEL" | "KARTADO" | "PLAN" | "PARAMETER_EVOLUTION" | "ORGANIZATION";

export type MetricViews = "LIMIT" | "SOLUTION" | "DECISION" | "ANALYSIS" | "NEITHER" | "P21PAVED" | "P21NOTPAVED" | "PAVEMENTPERFORMANCE" | "REINFORCEMENT" | "GAPS" | "BEFORE_KPI";

export type ParameterEvolutionProcessingStatus = "NEVER_PROCESSED" | "PROCESSING" | "PROCESSED" | "FAILED";

export type MeasurementFormat = "POINT" | "SEGMENT";

export type PlanOverviewItemType = "AVERAGE" | "SUM" | "RANKED";

export type GeometryType = "POINT" | "CURVE" | "SURFACE" | "GEOMETRYCOLLECTION" | "LINESTRING" | "LINEARRING" | "POLYGON" | "MULTIPOINT" | "MULTIPOLYGON" | "MULTILINESTRING";

export type CoordinateSystemAxisDirection = "NORTH" | "EAST" | "SOUTH" | "WEST" | "UP" | "DOWN" | "OTHER" | "UNKNOWN" | "GeocentricX" | "GeocentricY" | "GeocentricZ";

export type SortDirection = "ASC" | "DESC";

export type NullHandling = "NATIVE" | "NULLS_FIRST" | "NULLS_LAST";

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosUserResourceClient extends UserResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosUrciResourceClient extends UrciResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosIqdCalculationResourceClient extends IqdCalculationResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosMechanicalAnalysisResourceClient extends MechanicalAnalysisResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosPlanResourceClient extends PlanResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosMaterialsServicesResourceClient extends MaterialsServicesResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosUnifilarWorksResourceClient extends UnifilarWorksResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosAccountResourceClient extends AccountResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosCampaignResourceClient extends CampaignResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosParameterEvolutionResourceClient extends ParameterEvolutionResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosIcpResourceClient extends IcpResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosBuiltResourceClient extends BuiltResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosOrganizationResourceClient extends OrganizationResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosRoadResourceClient extends RoadResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosParametersVersionsResourceClient extends ParametersVersionsResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosWeighingResourceClient extends WeighingResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSolutionHistoricSourceClient extends SolutionHistoricSourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosAuditResourceClient extends AuditResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosImportHistoryResourceClient extends ImportHistoryResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosIggResourceClient extends IggResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosCostTableHistoricSourceClient extends CostTableHistoricSourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosPlanOverviewResourceClient extends PlanOverviewResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosGrowthRateResourceClient extends GrowthRateResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosIfiResourceClient extends IfiResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosIriResourceClient extends IriResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosWorksResourceClient extends WorksResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosProbingResourceClient extends ProbingResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosDataResourceClient extends DataResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosCostTableResourceClient extends CostTableResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosConstantSetResourceClient extends ConstantSetResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosAllPlansByProjectResourceClient extends AllPlansByProjectResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosConstantHistoricSourceClient extends ConstantHistoricSourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosBudgetLimitResourceClient extends BudgetLimitResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSegmentsResourceClient extends SegmentsResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosCriteriaSetResourceClient extends CriteriaSetResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosUnitPriceTablesResourceClient extends UnitPriceTablesResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosDecisionTreeHistoricSourceClient extends DecisionTreeHistoricSourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosRoleResourceClient extends RoleResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosGripResourceClient extends GripResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosStructureResourceClient extends StructureResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSeedDataResourceClient extends SeedDataResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosProjectResourceClient extends ProjectResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosVrdResourceClient extends VrdResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSatResourceClient extends SatResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosMetricLimitResourceClient extends MetricLimitResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosDecisionTreeResourceClient extends DecisionTreeResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSolutionResourceClient extends SolutionResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSystemResourceClient extends SystemResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosHsResourceClient extends HsResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosFwdResourceClient extends FwdResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosAuditLogResourceClient extends AuditLogResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosSystemParametersResourceClient extends SystemParametersResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosPlanHistoricSourceClient extends PlanHistoricSourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosMetadataResourceClient extends MetadataResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosLogsResourceClient extends LogsResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosNoiseResourceClient extends NoiseResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosTrResourceClient extends TrResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}

export class AxiosTestResourceClient extends TestResourceClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
